import React, { FC } from 'react';
import { IconProps } from '../../@types/ui';

// General Icons:
// Add
// Archive
// Brain
// Calendar
// Hamburger
// Messages
// MindBlown

const AddIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44771 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11V8Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
        fill="currentColor"
      />
    </svg>
  );
};
const ArchiveIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.95526 2.25C3.97013 2.25001 3.98505 2.25001 4.00001 2.25001L20.0448 2.25C20.4776 2.24995 20.8744 2.24991 21.1972 2.29331C21.5527 2.3411 21.9284 2.45355 22.2374 2.76257C22.5465 3.07159 22.6589 3.44732 22.7067 3.8028C22.7501 4.12561 22.7501 4.52245 22.75 4.95526V5.04475C22.7501 5.47757 22.7501 5.8744 22.7067 6.19721C22.6589 6.55269 22.5465 6.92842 22.2374 7.23744C21.9437 7.53121 21.5896 7.64733 21.25 7.69914V13.0564C21.25 14.8942 21.25 16.3498 21.0969 17.489C20.9392 18.6615 20.6071 19.6104 19.8588 20.3588C19.1104 21.1071 18.1615 21.4392 16.989 21.5969C15.8498 21.75 14.3942 21.75 12.5564 21.75H11.4436C9.60583 21.75 8.1502 21.75 7.01098 21.5969C5.83856 21.4392 4.88961 21.1071 4.14125 20.3588C3.39289 19.6104 3.06077 18.6615 2.90314 17.489C2.74998 16.3498 2.74999 14.8942 2.75001 13.0564L2.75001 7.69914C2.41038 7.64733 2.05634 7.53121 1.76257 7.23744C1.45355 6.92842 1.3411 6.55269 1.29331 6.19721C1.24991 5.8744 1.24995 5.47757 1.25 5.04476C1.25001 5.02988 1.25001 5.01496 1.25001 5.00001C1.25001 4.98505 1.25001 4.97013 1.25 4.95526C1.24995 4.52244 1.24991 4.12561 1.29331 3.8028C1.3411 3.44732 1.45355 3.07159 1.76257 2.76257C2.07159 2.45355 2.44732 2.3411 2.8028 2.29331C3.12561 2.24991 3.52244 2.24995 3.95526 2.25ZM4.25001 7.75001V13C4.25001 14.9068 4.2516 16.2615 4.38977 17.2892C4.52503 18.2952 4.7787 18.8749 5.20191 19.2981C5.62512 19.7213 6.20477 19.975 7.21086 20.1102C8.23852 20.2484 9.59319 20.25 11.5 20.25H12.5C14.4068 20.25 15.7615 20.2484 16.7892 20.1102C17.7952 19.975 18.3749 19.7213 18.7981 19.2981C19.2213 18.8749 19.475 18.2952 19.6102 17.2892C19.7484 16.2615 19.75 14.9068 19.75 13V7.75001H4.25001ZM2.82324 3.82324L2.82568 3.82187C2.82761 3.82086 2.83093 3.81924 2.83597 3.81717C2.85775 3.80821 2.90611 3.79291 3.00267 3.77993C3.21339 3.7516 3.5074 3.75001 4.00001 3.75001H20C20.4926 3.75001 20.7866 3.7516 20.9973 3.77993C21.0939 3.79291 21.1423 3.80821 21.164 3.81717C21.1691 3.81924 21.1724 3.82086 21.1743 3.82187L21.1768 3.82323L21.1781 3.82568C21.1792 3.82761 21.1808 3.83093 21.1828 3.83597C21.1918 3.85775 21.2071 3.90611 21.2201 4.00267C21.2484 4.21339 21.25 4.5074 21.25 5.00001C21.25 5.49261 21.2484 5.78662 21.2201 5.99734C21.2071 6.0939 21.1918 6.14226 21.1828 6.16404C21.1808 6.16909 21.1792 6.1724 21.1781 6.17434L21.1768 6.17678L21.1743 6.17815C21.1724 6.17916 21.1691 6.18077 21.164 6.18285C21.1423 6.19181 21.0939 6.2071 20.9973 6.22008C20.7866 6.24841 20.4926 6.25001 20 6.25001H4.00001C3.5074 6.25001 3.21339 6.24841 3.00267 6.22008C2.90611 6.2071 2.85775 6.19181 2.83597 6.18285C2.83093 6.18077 2.82761 6.17916 2.82568 6.17815L2.82324 6.17677L2.82187 6.17434C2.82086 6.1724 2.81924 6.16909 2.81717 6.16404C2.80821 6.14226 2.79291 6.0939 2.77993 5.99734C2.7516 5.78662 2.75001 5.49261 2.75001 5.00001C2.75001 4.5074 2.7516 4.21339 2.77993 4.00267C2.79291 3.90611 2.80821 3.85775 2.81717 3.83597C2.81924 3.83093 2.82086 3.82761 2.82187 3.82568L2.82324 3.82324ZM2.82324 6.17677C2.82284 6.17636 2.82297 6.17644 2.82324 6.17677V6.17677ZM10.4782 9.75001H13.5218C13.736 9.74999 13.9329 9.74998 14.0982 9.76126C14.2759 9.77338 14.4712 9.80099 14.6697 9.88322C15.0985 10.0608 15.4392 10.4015 15.6168 10.8303C15.699 11.0288 15.7266 11.2242 15.7388 11.4018C15.75 11.5671 15.75 11.764 15.75 11.9782V12.0218C15.75 12.236 15.75 12.4329 15.7388 12.5982C15.7266 12.7759 15.699 12.9712 15.6168 13.1697C15.4392 13.5985 15.0985 13.9392 14.6697 14.1168C14.4712 14.199 14.2759 14.2266 14.0982 14.2388C13.9329 14.25 13.736 14.25 13.5218 14.25H10.4782C10.264 14.25 10.0671 14.25 9.9018 14.2388C9.72416 14.2266 9.52881 14.199 9.33031 14.1168C8.90151 13.9392 8.56083 13.5985 8.38322 13.1697C8.30099 12.9712 8.27338 12.7759 8.26126 12.5982C8.24998 12.4329 8.24999 12.236 8.25001 12.0218V11.9782C8.24999 11.764 8.24998 11.5671 8.26126 11.4018C8.27338 11.2242 8.30099 11.0288 8.38322 10.8303C8.56083 10.4015 8.90151 10.0608 9.33031 9.88322C9.52881 9.80099 9.72416 9.77338 9.9018 9.76126C10.0671 9.74998 10.264 9.74999 10.4782 9.75001ZM9.90131 11.2703C9.84248 11.2956 9.79559 11.3425 9.77031 11.4013C9.76844 11.4087 9.76234 11.4371 9.75778 11.5039C9.75041 11.6119 9.75001 11.7568 9.75001 12C9.75001 12.2432 9.75041 12.3881 9.75778 12.4961C9.76234 12.5629 9.76844 12.5913 9.77031 12.5987C9.79559 12.6575 9.84248 12.7044 9.90131 12.7297C9.90867 12.7316 9.93707 12.7377 10.0039 12.7422C10.1119 12.7496 10.2568 12.75 10.5 12.75H13.5C13.7432 12.75 13.8881 12.7496 13.9961 12.7422C14.0629 12.7377 14.0913 12.7316 14.0987 12.7297C14.1575 12.7044 14.2044 12.6575 14.2297 12.5987C14.2316 12.5913 14.2377 12.5629 14.2422 12.4961C14.2496 12.3881 14.25 12.2432 14.25 12C14.25 11.7568 14.2496 11.6119 14.2422 11.5039C14.2377 11.4371 14.2316 11.4087 14.2297 11.4013C14.2044 11.3425 14.1575 11.2956 14.0987 11.2703C14.0913 11.2684 14.0629 11.2623 13.9961 11.2578C13.8881 11.2504 13.7432 11.25 13.5 11.25H10.5C10.2568 11.25 10.1119 11.2504 10.0039 11.2578C9.93707 11.2623 9.90866 11.2684 9.90131 11.2703Z"
        fill="currentColor"
      />
    </svg>
  );
};
const AttachPaperClipIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M4.53564 11.4647L11.4299 4.5704C13.4802 2.52015 16.8044 2.52015 18.8546 4.5704C20.9049 6.62066 20.9046 9.94496 18.8544 11.9952L10.8994 19.9502C9.53258 21.317 7.31688 21.3168 5.95004 19.95C4.58321 18.5831 4.58287 16.3673 5.94971 15.0005L13.9047 7.0455C14.5881 6.36208 15.6967 6.36208 16.3801 7.0455C17.0635 7.72892 17.0631 8.83669 16.3796 9.52011L9.48535 16.4144"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const AudioWavIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1,16V8A1,1,0,0,1,3,8v8a1,1,0,0,1-2,0Zm7,4V4A1,1,0,0,0,6,4V20a1,1,0,0,0,2,0Zm5,2V2a1,1,0,0,0-2,0V22a1,1,0,0,0,2,0Zm5-2V4a1,1,0,0,0-2,0V20a1,1,0,0,0,2,0ZM22,7a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V8A1,1,0,0,0,22,7Z" />
    </svg>
  );
};
const BackIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M222.927 580.115l301.354 328.512c24.354 28.708 20.825 71.724-7.883 96.078s-71.724 20.825-96.078-7.883L19.576 559.963a67.846 67.846 0 01-13.784-20.022 68.03 68.03 0 01-5.977-29.488l.001-.063a68.343 68.343 0 017.265-29.134 68.28 68.28 0 011.384-2.6 67.59 67.59 0 0110.102-13.687L429.966 21.113c25.592-27.611 68.721-29.247 96.331-3.656s29.247 68.721 3.656 96.331L224.088 443.784h730.46c37.647 0 68.166 30.519 68.166 68.166s-30.519 68.166-68.166 68.166H222.927z" />
    </svg>
  );
};

const BookIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.4V20M12 10.4C12 8.15979 12 7.03969 11.564 6.18404C11.1805 5.43139 10.5686 4.81947 9.81596 4.43597C8.96031 4 7.84021 4 5.6 4H4.6C4.03995 4 3.75992 4 3.54601 4.10899C3.35785 4.20487 3.20487 4.35785 3.10899 4.54601C3 4.75992 3 5.03995 3 5.6V16.4C3 16.9601 3 17.2401 3.10899 17.454C3.20487 17.6422 3.35785 17.7951 3.54601 17.891C3.75992 18 4.03995 18 4.6 18H7.54668C8.08687 18 8.35696 18 8.61814 18.0466C8.84995 18.0879 9.0761 18.1563 9.29191 18.2506C9.53504 18.3567 9.75977 18.5065 10.2092 18.8062L12 20M12 10.4C12 8.15979 12 7.03969 12.436 6.18404C12.8195 5.43139 13.4314 4.81947 14.184 4.43597C15.0397 4 16.1598 4 18.4 4H19.4C19.9601 4 20.2401 4 20.454 4.10899C20.6422 4.20487 20.7951 4.35785 20.891 4.54601C21 4.75992 21 5.03995 21 5.6V16.4C21 16.9601 21 17.2401 20.891 17.454C20.7951 17.6422 20.6422 17.7951 20.454 17.891C20.2401 18 19.9601 18 19.4 18H16.4533C15.9131 18 15.643 18 15.3819 18.0466C15.15 18.0879 14.9239 18.1563 14.7081 18.2506C14.465 18.3567 14.2402 18.5065 13.7908 18.8062L12 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const BrainIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 22 20"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11 16.5A2.493 2.493 0 0 1 6.51 18H6.5a2.468 2.468 0 0 1-2.4-3.154 2.98 2.98 0 0 1-.85-5.274 2.468 2.468 0 0 1 .921-3.182 2.477 2.477 0 0 1 1.875-3.344 2.5 2.5 0 0 1 3.41-1.856A2.5 2.5 0 0 1 11 3.5m0 13v-13m0 13a2.492 2.492 0 0 0 4.49 1.5h.01a2.467 2.467 0 0 0 2.403-3.154 2.98 2.98 0 0 0 .847-5.274 2.468 2.468 0 0 0-.921-3.182 2.479 2.479 0 0 0-1.875-3.344A2.5 2.5 0 0 0 13.5 1 2.5 2.5 0 0 0 11 3.5m-8 5a2.5 2.5 0 0 1 3.48-2.3m-.28 8.551a3 3 0 0 1-2.953-5.185M19 8.5a2.5 2.5 0 0 0-3.481-2.3m.28 8.551a3 3 0 0 0 2.954-5.185"
      />
    </svg>
  );
};

const BriefcaseIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 4C10.4477 4 10 4.44772 10 5V6H14V5C14 4.44772 13.5523 4 13 4H11ZM16 6V5C16 3.34315 14.6569 2 13 2H11C9.34315 2 8 3.34315 8 5V6H4C2.89543 6 2 6.89543 2 8V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V8C22 6.89543 21.1046 6 20 6H16ZM9 8H4V19H20V8H15H9Z"
        fill="currentColor"
      />
    </svg>
  );
};

const CalendarIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5 1v3m5-3v3m5-3v3M1 7h7m1.506 3.429 2.065 2.065M19 7h-2M2 3h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm6 13H6v-2l5.227-5.292a1.46 1.46 0 0 1 2.065 2.065L8 16Z"
      />
    </svg>
  );
};

const CameraIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 16.8V9.2C3 8.0799 3 7.51984 3.21799 7.09202C3.40973 6.71569 3.71569 6.40973 4.09202 6.21799C4.51984 6 5.0799 6 6.2 6H7.25464C7.37758 6 7.43905 6 7.49576 5.9935C7.79166 5.95961 8.05705 5.79559 8.21969 5.54609C8.25086 5.49827 8.27836 5.44328 8.33333 5.33333C8.44329 5.11342 8.49827 5.00346 8.56062 4.90782C8.8859 4.40882 9.41668 4.08078 10.0085 4.01299C10.1219 4 10.2448 4 10.4907 4H13.5093C13.7552 4 13.8781 4 13.9915 4.01299C14.5833 4.08078 15.1141 4.40882 15.4394 4.90782C15.5017 5.00345 15.5567 5.11345 15.6667 5.33333C15.7216 5.44329 15.7491 5.49827 15.7803 5.54609C15.943 5.79559 16.2083 5.95961 16.5042 5.9935C16.561 6 16.6224 6 16.7454 6H17.8C18.9201 6 19.4802 6 19.908 6.21799C20.2843 6.40973 20.5903 6.71569 20.782 7.09202C21 7.51984 21 8.0799 21 9.2V16.8C21 17.9201 21 18.4802 20.782 18.908C20.5903 19.2843 20.2843 19.5903 19.908 19.782C19.4802 20 18.9201 20 17.8 20H6.2C5.0799 20 4.51984 20 4.09202 19.782C3.71569 19.5903 3.40973 19.2843 3.21799 18.908C3 18.4802 3 17.9201 3 16.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CheckIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CheckCircleIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`w-${width} h-${height}`}
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clipRule="evenodd"
      />
    </svg>
  );
};

const ClipboardIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 5.00005C7.01165 5.00082 6.49359 5.01338 6.09202 5.21799C5.71569 5.40973 5.40973 5.71569 5.21799 6.09202C5 6.51984 5 7.07989 5 8.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.07989 21 8.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V8.2C19 7.07989 19 6.51984 18.782 6.09202C18.5903 5.71569 18.2843 5.40973 17.908 5.21799C17.5064 5.01338 16.9884 5.00082 16 5.00005M8 5.00005V7H16V5.00005M8 5.00005V4.70711C8 4.25435 8.17986 3.82014 8.5 3.5C8.82014 3.17986 9.25435 3 9.70711 3H14.2929C14.7456 3 15.1799 3.17986 15.5 3.5C15.8201 3.82014 16 4.25435 16 4.70711V5.00005M16 11H14M16 16H14M8 11L9 12L11 10M8 16L9 17L11 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ClockCircleIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        fill="currentcolor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V11.6893L15.0303 13.9697C15.3232 14.2626 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2626 15.3232 13.9697 15.0303L11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V8C11.25 7.58579 11.5858 7.25 12 7.25Z"
        fill="none"
      />
    </svg>
  );
};
const CopyIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11C6 8.17157 6 6.75736 6.87868 5.87868C7.75736 5 9.17157 5 12 5H15C17.8284 5 19.2426 5 20.1213 5.87868C21 6.75736 21 8.17157 21 11V16C21 18.8284 21 20.2426 20.1213 21.1213C19.2426 22 17.8284 22 15 22H12C9.17157 22 7.75736 22 6.87868 21.1213C6 20.2426 6 18.8284 6 16V11Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M6 19C4.34315 19 3 17.6569 3 16V10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H15C16.6569 2 18 3.34315 18 5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};
const DotsIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.001 7.8a2.2 2.2 0 1 0 0 4.402A2.2 2.2 0 0 0 10 7.8zm0-2.6A2.2 2.2 0 1 0 9.999.8a2.2 2.2 0 0 0 .002 4.4zm0 9.6a2.2 2.2 0 1 0 0 4.402 2.2 2.2 0 0 0 0-4.402z" />
    </svg>
  );
};
const DuplicateIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.869 6.092V3.955h1.25v2.137h2.118v1.25h-2.118v2.213h-1.25V7.342H6.636v-1.25H8.87z" />
      <path
        fillRule="evenodd"
        d="M15.5 10.76c0 .69-.56 1.25-1.25 1.25H4.623c-.69 0-1.25-.56-1.25-1.25V2.75c0-.69.56-1.25 1.25-1.25h9.627c.69 0 1.25.56 1.25 1.25v8.01zm-1.25 0H4.623V2.75h9.627v8.01z"
      />
      <path d="M1.75 13.25h9.615v-.62h1.25v.62c0 .69-.56 1.25-1.25 1.25H1.75c-.69 0-1.25-.56-1.25-1.25v-8C.5 4.56 1.06 4 1.75 4h1.005v1.25H1.75v8z" />
    </svg>
  );
};
const EditIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1213 2.70705C19.9497 1.53548 18.0503 1.53547 16.8787 2.70705L15.1989 4.38685L7.29289 12.2928C7.16473 12.421 7.07382 12.5816 7.02986 12.7574L6.02986 16.7574C5.94466 17.0982 6.04451 17.4587 6.29289 17.707C6.54127 17.9554 6.90176 18.0553 7.24254 17.9701L11.2425 16.9701C11.4184 16.9261 11.5789 16.8352 11.7071 16.707L19.5556 8.85857L21.2929 7.12126C22.4645 5.94969 22.4645 4.05019 21.2929 2.87862L21.1213 2.70705ZM18.2929 4.12126C18.6834 3.73074 19.3166 3.73074 19.7071 4.12126L19.8787 4.29283C20.2692 4.68336 20.2692 5.31653 19.8787 5.70705L18.8622 6.72357L17.3068 5.10738L18.2929 4.12126ZM15.8923 6.52185L17.4477 8.13804L10.4888 15.097L8.37437 15.6256L8.90296 13.5112L15.8923 6.52185ZM4 7.99994C4 7.44766 4.44772 6.99994 5 6.99994H10C10.5523 6.99994 11 6.55223 11 5.99994C11 5.44766 10.5523 4.99994 10 4.99994H5C3.34315 4.99994 2 6.34309 2 7.99994V18.9999C2 20.6568 3.34315 21.9999 5 21.9999H16C17.6569 21.9999 19 20.6568 19 18.9999V13.9999C19 13.4477 18.5523 12.9999 18 12.9999C17.4477 12.9999 17 13.4477 17 13.9999V18.9999C17 19.5522 16.5523 19.9999 16 19.9999H5C4.44772 19.9999 4 19.5522 4 18.9999V7.99994Z"
        fill="currentColor"
      />
    </svg>
  );
};

const EigthNoteIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3187 2.50498C13.0514 2.35716 11.8489 3.10033 11.4144 4.29989C11.3165 4.57023 11.2821 4.86251 11.266 5.16888C11.2539 5.40001 11.2509 5.67552 11.2503 6L11.25 6.45499C11.25 6.4598 11.25 6.4646 11.25 6.46938V14.5359C10.4003 13.7384 9.25721 13.25 8 13.25C5.37665 13.25 3.25 15.3766 3.25 18C3.25 20.6234 5.37665 22.75 8 22.75C10.6234 22.75 12.75 20.6234 12.75 18V9.21059C12.8548 9.26646 12.9683 9.32316 13.0927 9.38527L15.8002 10.739C16.2185 10.9481 16.5589 11.1183 16.8378 11.2399C17.119 11.3625 17.3958 11.4625 17.6814 11.4958C18.9486 11.6436 20.1511 10.9004 20.5856 9.70089C20.6836 9.43055 20.7179 9.13826 20.7341 8.83189C20.75 8.52806 20.75 8.14752 20.75 7.67988L20.7501 7.59705C20.7502 7.2493 20.7503 6.97726 20.701 6.71946C20.574 6.05585 20.2071 5.46223 19.6704 5.05185C19.4618 4.89242 19.2185 4.77088 18.9074 4.6155L16.1999 3.26179C15.7816 3.05264 15.4412 2.88244 15.1623 2.76086C14.8811 2.63826 14.6043 2.53829 14.3187 2.50498Z"
        fill="currentColor"
      />
    </svg>
  );
};
const EmojiSingIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8 8.1C20.8 8.59706 20.3971 9 19.9 9C19.4029 9 19 8.59706 19 8.1C19 7.60294 19.4029 7.2 19.9 7.2C20.3971 7.2 20.8 7.60294 20.8 8.1Z"
        fill="currentColor"
      />
      <path
        d="M20.8 8.1C20.8 8.59706 20.3971 9 19.9 9C19.4029 9 19 8.59706 19 8.1C19 7.60294 19.4029 7.2 19.9 7.2C20.3971 7.2 20.8 7.60294 20.8 8.1ZM20.8 8.1V3.6C20.8 3.26863 21.0686 3 21.4 3H23"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16 17C14.8954 17 14 16.1046 14 15C14 13.8954 14.8954 13 16 13C17.1046 13 18 13.8954 18 15C18 16.1046 17.1046 17 16 17Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9506 13C21.4489 18.0533 17.1853 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C13.4222 2 14.7751 2.2969 16 2.83209"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5C9 8.77614 8.77614 9 8.5 9Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 9C15.2239 9 15 8.77614 15 8.5C15 8.22386 15.2239 8 15.5 8C15.7761 8 16 8.22386 16 8.5C16 8.77614 15.7761 9 15.5 9Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ExitIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width * 1.25} h-${height * 1.25}`}
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5.002 21h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2h-14c-1.103 0-2 .897-2 2v6.001H10V7l6 5-6 5v-3.999H3.002V19c0 1.103.897 2 2 2z" />
    </svg>
  );
};
const ExpandIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 9.233C4.75 9.64721 5.08579 9.983 5.5 9.983C5.91421 9.983 6.25 9.64721 6.25 9.233H4.75ZM6.25 5.5C6.25 5.08579 5.91421 4.75 5.5 4.75C5.08579 4.75 4.75 5.08579 4.75 5.5H6.25ZM5.5 4.75C5.08579 4.75 4.75 5.08579 4.75 5.5C4.75 5.91421 5.08579 6.25 5.5 6.25V4.75ZM9.233 6.25C9.64721 6.25 9.983 5.91421 9.983 5.5C9.983 5.08579 9.64721 4.75 9.233 4.75V6.25ZM6.03033 4.96967C5.73744 4.67678 5.26256 4.67678 4.96967 4.96967C4.67678 5.26256 4.67678 5.73744 4.96967 6.03033L6.03033 4.96967ZM9.96967 11.0303C10.2626 11.3232 10.7374 11.3232 11.0303 11.0303C11.3232 10.7374 11.3232 10.2626 11.0303 9.96967L9.96967 11.0303ZM15.767 18.75C15.3528 18.75 15.017 19.0858 15.017 19.5C15.017 19.9142 15.3528 20.25 15.767 20.25V18.75ZM19.5 20.25C19.9142 20.25 20.25 19.9142 20.25 19.5C20.25 19.0858 19.9142 18.75 19.5 18.75V20.25ZM18.75 19.5C18.75 19.9142 19.0858 20.25 19.5 20.25C19.9142 20.25 20.25 19.9142 20.25 19.5H18.75ZM20.25 15.767C20.25 15.3528 19.9142 15.017 19.5 15.017C19.0858 15.017 18.75 15.3528 18.75 15.767H20.25ZM18.9697 20.0303C19.2626 20.3232 19.7374 20.3232 20.0303 20.0303C20.3232 19.7374 20.3232 19.2626 20.0303 18.9697L18.9697 20.0303ZM15.0303 13.9697C14.7374 13.6768 14.2626 13.6768 13.9697 13.9697C13.6768 14.2626 13.6768 14.7374 13.9697 15.0303L15.0303 13.9697ZM6.25 15.767C6.25 15.3528 5.91421 15.017 5.5 15.017C5.08579 15.017 4.75 15.3528 4.75 15.767H6.25ZM4.75 19.5C4.75 19.9142 5.08579 20.25 5.5 20.25C5.91421 20.25 6.25 19.9142 6.25 19.5H4.75ZM5.5 18.75C5.08579 18.75 4.75 19.0858 4.75 19.5C4.75 19.9142 5.08579 20.25 5.5 20.25V18.75ZM9.233 20.25C9.64721 20.25 9.983 19.9142 9.983 19.5C9.983 19.0858 9.64721 18.75 9.233 18.75V20.25ZM4.96967 18.9697C4.67678 19.2626 4.67678 19.7374 4.96967 20.0303C5.26256 20.3232 5.73744 20.3232 6.03033 20.0303L4.96967 18.9697ZM11.0303 15.0303C11.3232 14.7374 11.3232 14.2626 11.0303 13.9697C10.7374 13.6768 10.2626 13.6768 9.96967 13.9697L11.0303 15.0303ZM15.767 4.75C15.3528 4.75 15.017 5.08579 15.017 5.5C15.017 5.91421 15.3528 6.25 15.767 6.25V4.75ZM19.5 6.25C19.9142 6.25 20.25 5.91421 20.25 5.5C20.25 5.08579 19.9142 4.75 19.5 4.75V6.25ZM20.25 5.5C20.25 5.08579 19.9142 4.75 19.5 4.75C19.0858 4.75 18.75 5.08579 18.75 5.5H20.25ZM18.75 9.233C18.75 9.64721 19.0858 9.983 19.5 9.983C19.9142 9.983 20.25 9.64721 20.25 9.233H18.75ZM20.0303 6.03033C20.3232 5.73744 20.3232 5.26256 20.0303 4.96967C19.7374 4.67678 19.2626 4.67678 18.9697 4.96967L20.0303 6.03033ZM13.9697 9.96967C13.6768 10.2626 13.6768 10.7374 13.9697 11.0303C14.2626 11.3232 14.7374 11.3232 15.0303 11.0303L13.9697 9.96967ZM6.25 9.233V5.5H4.75V9.233H6.25ZM5.5 6.25H9.233V4.75H5.5V6.25ZM4.96967 6.03033L9.96967 11.0303L11.0303 9.96967L6.03033 4.96967L4.96967 6.03033ZM15.767 20.25H19.5V18.75H15.767V20.25ZM20.25 19.5V15.767H18.75V19.5H20.25ZM20.0303 18.9697L15.0303 13.9697L13.9697 15.0303L18.9697 20.0303L20.0303 18.9697ZM4.75 15.767V19.5H6.25V15.767H4.75ZM5.5 20.25H9.233V18.75H5.5V20.25ZM6.03033 20.0303L11.0303 15.0303L9.96967 13.9697L4.96967 18.9697L6.03033 20.0303ZM15.767 6.25H19.5V4.75H15.767V6.25ZM18.75 5.5V9.233H20.25V5.5H18.75ZM18.9697 4.96967L13.9697 9.96967L15.0303 11.0303L20.0303 6.03033L18.9697 4.96967Z"
        fill="currentcolor"
      />
    </svg>
  );
};
const ExternalLinkIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentcolor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M960 704c-35.346 0-64 28.654-64 64v64c0 35.346-28.654 64-64 64H192c-35.346 0-64-28.654-64-64V192c0-35.346 28.654-64 64-64h64c35.346 0 64-28.654 64-64S291.346 0 256 0h-64C85.961 0 0 85.961 0 192v640c0 106.039 85.961 192 192 192h640c106.039 0 192-85.961 192-192v-64c0-35.346-28.654-64-64-64z" />
      <path d="M1023.876 51.52c0-1.92 0-3.84-1.6-5.44a63.957 63.957 0 00-1.92-6.4 63.973 63.973 0 00-3.2-6.4s0-3.2-2.56-4.8a63.989 63.989 0 00-17.6-17.6L991.876 8l-6.08-3.2-6.72-1.92h-5.44A64.028 64.028 0 00959.876 0h-384c-35.346 0-64 28.654-64 64s28.654 64 64 64h229.44l-370.56 370.88c-25.007 25.007-25.007 65.553 0 90.56s65.553 25.007 90.56 0l370.56-370.88V448c0 35.346 28.654 64 64 64s64-28.654 64-64V64c.407-4.15.407-8.33 0-12.48z" />
    </svg>
  );
};
const ExpandIcon2: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 9V5.6C4 5.03995 4 4.75992 4.10899 4.54601C4.20487 4.35785 4.35785 4.20487 4.54601 4.109C4.75992 4 5.03995 4 5.6 4L9 4M4 15V18.4C4 18.9601 4 19.2401 4.10899 19.454C4.20487 19.6422 4.35785 19.7951 4.54601 19.891C4.75992 20 5.03995 20 5.6 20L9 20M15 4H18.4C18.9601 4 19.2401 4 19.454 4.10899C19.6422 4.20487 19.7951 4.35785 19.891 4.54601C20 4.75992 20 5.03995 20 5.6V9M20 15V18.4C20 18.9601 20 19.2401 19.891 19.454C19.7951 19.6422 19.6422 19.7951 19.454 19.891C19.2401 20 18.9601 20 18.4 20H15"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const ExpandIcon3: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2,3V21a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3ZM4,4H20V20H10V15a1,1,0,0,0-1-1H4ZM4,16H8v4H4Zm7.293-3.293a1,1,0,0,1,0-1.414L14.086,8.5H13a1,1,0,0,1,0-2h3.5a1,1,0,0,1,.923.618A1.01,1.01,0,0,1,17.5,7.5V11a1,1,0,0,1-2,0V9.914l-2.793,2.793a1,1,0,0,1-1.414,0Z" />
    </svg>
  );
};
const EyeIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.30147 15.5771C4.77832 14.2684 3.6904 12.7726 3.18002 12C3.6904 11.2274 4.77832 9.73158 6.30147 8.42294C7.87402 7.07185 9.81574 6 12 6C14.1843 6 16.1261 7.07185 17.6986 8.42294C19.2218 9.73158 20.3097 11.2274 20.8201 12C20.3097 12.7726 19.2218 14.2684 17.6986 15.5771C16.1261 16.9282 14.1843 18 12 18C9.81574 18 7.87402 16.9282 6.30147 15.5771ZM12 4C9.14754 4 6.75717 5.39462 4.99812 6.90595C3.23268 8.42276 2.00757 10.1376 1.46387 10.9698C1.05306 11.5985 1.05306 12.4015 1.46387 13.0302C2.00757 13.8624 3.23268 15.5772 4.99812 17.0941C6.75717 18.6054 9.14754 20 12 20C14.8525 20 17.2429 18.6054 19.002 17.0941C20.7674 15.5772 21.9925 13.8624 22.5362 13.0302C22.947 12.4015 22.947 11.5985 22.5362 10.9698C21.9925 10.1376 20.7674 8.42276 19.002 6.90595C17.2429 5.39462 14.8525 4 12 4ZM10 12C10 10.8954 10.8955 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8955 14 10 13.1046 10 12ZM12 8C9.7909 8 8.00004 9.79086 8.00004 12C8.00004 14.2091 9.7909 16 12 16C14.2092 16 16 14.2091 16 12C16 9.79086 14.2092 8 12 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
const FilterIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H4C3.44772 8 3 7.55228 3 7ZM6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12ZM9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17Z"
        fill="currentColor"
      />
    </svg>
  );
};
const ForwardIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M799.584 440.059L498.23 111.547c-24.354-28.708-20.825-71.724 7.883-96.078s71.724-20.825 96.078 7.883l400.744 436.859a67.846 67.846 0 0113.784 20.022 68.03 68.03 0 015.977 29.488l-.001.063a68.343 68.343 0 01-7.265 29.134 68.28 68.28 0 01-1.384 2.6 67.59 67.59 0 01-10.102 13.687L592.545 999.061c-25.592 27.611-68.721 29.247-96.331 3.656s-29.247-68.721-3.656-96.331L798.423 576.39H67.963c-37.647 0-68.166-30.519-68.166-68.166s30.519-68.166 68.166-68.166h731.621z" />
    </svg>
  );
};
const FastForwardIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M855.281 308.99v522.256L0 309.524v1300.242l855.281-521.83V1610.3l1064.612-650.655z"
        fillRule="evenodd"
      />
    </svg>
  );
};
const FullScreenIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 4C23 2.34315 21.6569 1 20 1H16C15.4477 1 15 1.44772 15 2C15 2.55228 15.4477 3 16 3H20C20.5523 3 21 3.44772 21 4V8C21 8.55228 21.4477 9 22 9C22.5523 9 23 8.55228 23 8V4Z"
        fill="currentColor"
      />
      <path
        d="M23 16C23 15.4477 22.5523 15 22 15C21.4477 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H16C15.4477 21 15 21.4477 15 22C15 22.5523 15.4477 23 16 23H20C21.6569 23 23 21.6569 23 20V16Z"
        fill="currentColor"
      />
      <path
        d="M4 21H8C8.55228 21 9 21.4477 9 22C9 22.5523 8.55228 23 8 23H4C2.34315 23 1 21.6569 1 20V16C1 15.4477 1.44772 15 2 15C2.55228 15 3 15.4477 3 16V20C3 20.5523 3.44772 21 4 21Z"
        fill="currentColor"
      />
      <path
        d="M1 8C1 8.55228 1.44772 9 2 9C2.55228 9 3 8.55228 3 8L3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 2.55228 9 2C9 1.44772 8.55228 1 8 1H4C2.34315 1 1 2.34315 1 4V8Z"
        fill="currentColor"
      />
    </svg>
  );
};

const GuitarCaseIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentcolor"
      className={`w-${width} h-${height}`}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 511.995 511.995"
    >
      <g>
        <g>
          <path
            d="M500.965,98.363c7.104-7.083,11.029-16.512,11.029-26.539s-3.904-19.456-11.008-26.539L466.661,10.96
			c-14.592-14.613-38.421-14.613-53.035,0L250.383,174.203c-3.008,2.987-7.637,3.947-12.117,2.325
			c-20.416-7.232-40.32-8.725-58.005-5.12l-58.517-58.517c-7.509-7.509-19.392-8.363-27.883-1.984l-85.333,64
			c-9.045,6.805-11.221,19.477-4.949,28.907l37.163,55.744c-2.667,2.197-5.589,4.011-8.085,6.507
			C-16.667,315.387-8.966,403.365,49.829,462.16c27.883,27.904,63.189,45.333,99.392,49.067c4.907,0.512,9.749,0.768,14.528,0.768
			c32.064,0,60.821-11.371,82.155-32.683c22.613-22.613,33.92-53.675,32.533-87.68c16.32-2.752,30.72-9.899,41.856-21.013
			c22.912-22.933,28.565-59.157,15.147-96.896c-1.6-4.459-0.683-9.109,2.347-12.139L500.965,98.363z M120.357,233.552
			c-14.848-0.597-28.8,1.621-41.92,5.632l-28.181-42.24l54.4-40.811l36.181,36.181C130.042,203.344,123.045,217.467,120.357,233.552
			z"
          />
        </g>
      </g>
    </svg>
  );
};

const GuitarPickIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentcolor"
      className={`w-${width} h-${height}`}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g transform="translate(0 -1)">
        <g>
          <g>
            <path
              d="M443.313,40.189C398.235,16.019,326.214,1,255.387,1C185.137,1,113.521,15.848,68.55,39.784
             C35.803,57.213,13.617,87.101,4.486,121.021l491.947,98.389c3.605-8.96,6.571-17.003,8.747-23.701
             C524.785,135.357,498.779,69.949,443.313,40.189z"
            />
            <path
              d="M255.347,513h0.021h0.128c60.608,0,128.128-84.139,178.325-168.725L34.525,264.403
             C82.611,364.947,175.133,512.957,255.347,513z"
            />
            <path
              d="M6.154,196.462c1.899,5.824,4.416,12.693,7.403,20.245l442.304,88.448c8.512-15.915,16.213-31.339,23.019-45.76
             L0.33,163.694C1.034,174.638,2.613,185.604,6.154,196.462z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const HamburgerNavIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46447 20.5355C4.92893 22 7.28595 22 12 22C16.714 22 19.0711 22 20.5355 20.5355C22 19.0711 22 16.714 22 12C22 7.28595 22 4.92893 20.5355 3.46447C19.0711 2 16.714 2 12 2C7.28595 2 4.92893 2 3.46447 3.46447C2 4.92893 2 7.28595 2 12C2 16.714 2 19.0711 3.46447 20.5355ZM18.75 16C18.75 16.4142 18.4142 16.75 18 16.75H6C5.58579 16.75 5.25 16.4142 5.25 16C5.25 15.5858 5.58579 15.25 6 15.25H18C18.4142 15.25 18.75 15.5858 18.75 16ZM18 12.75C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H6C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H18ZM18.75 8C18.75 8.41421 18.4142 8.75 18 8.75H6C5.58579 8.75 5.25 8.41421 5.25 8C5.25 7.58579 5.58579 7.25 6 7.25H18C18.4142 7.25 18.75 7.58579 18.75 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
const HomeIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`w-${width} h-${height}`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentcolor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
      />
    </svg>
  );
};

const HereNowIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`w-${width} h-${height}`}
      fill="currentcolor"
      viewBox="0 0 26.458334 26.458323"
    >
      <path
        fill="currentcolor"
        strokeWidth="2"
        d="m 134.7857,51.414807 c -2.75851,-0.169668 -5.29357,-0.762671 -7.25915,-1.697868 -1.35542,-0.645003 -2.25186,-1.264481 -3.10197,-2.143794 -0.79176,-0.818588 -1.23998,-1.586401 -1.50543,-2.576789 -0.14502,-0.54217 -0.14502,-1.5762 -1.7e-4,-2.118886 0.41589,-1.553025 1.44401,-2.831049 3.17789,-3.94913 0.60925,-0.393002 1.71472,-0.930513 2.53723,-1.233865 0.11585,-0.0425 0.21003,-0.105584 0.21003,-0.140334 0,-0.035 -0.05,-0.276335 -0.11335,-0.537086 -0.16502,-0.691754 -0.35504,-1.6521 -0.49089,-2.482713 -0.10168,-0.622837 -0.11918,-0.859455 -0.11918,-1.633309 8e-5,-0.805171 0.0167,-0.967463 0.11668,-1.472166 0.0667,-0.312002 0.17752,-0.758921 0.25253,-0.99323 0.17002,-0.53242 0.62091,-1.455466 0.9517,-1.948961 1.40676,-2.099053 3.72729,-3.399818 6.27077,-3.515118 1.32275,-0.06 2.58899,0.206167 3.79914,0.798504 1.65912,0.812087 2.84852,2.000919 3.66745,3.665661 0.32838,0.668254 0.50923,1.203456 0.67092,1.993102 0.10418,0.50467 0.11668,0.667004 0.11668,1.472166 8e-5,0.773838 -0.0167,1.010447 -0.11918,1.633309 -0.12668,0.776671 -0.31087,1.706018 -0.49256,2.488805 -0.0583,0.264168 -0.11168,0.503669 -0.11168,0.53217 0,0.02833 0.24336,0.147417 0.5409,0.264084 0.61091,0.239502 1.73179,0.803171 2.21019,1.111731 1.72913,1.115014 2.75834,2.394855 3.17356,3.946338 0.0833,0.312752 0.10084,0.489169 0.10084,1.059439 8.3e-4,0.615253 -0.008,0.72867 -0.12251,1.125664 -0.15002,0.538836 -0.4734,1.229765 -0.7876,1.686826 -0.27503,0.399169 -0.98654,1.153256 -1.42759,1.512466 -1.33175,1.084673 -3.2104,1.964094 -5.36742,2.512522 -1.69479,0.430919 -3.20914,0.61792 -5.1908,0.64117 -0.72843,0.0083 -1.44452,0.0082 -1.59028,-8.33e-4 z m 1.55469,-1.911694 c 0.97395,-0.799754 2.68266,-4.341098 3.95299,-8.192743 1.0808,-3.276868 1.85014,-6.537952 1.92148,-8.144485 0.075,-1.769035 -0.57507,-3.422619 -1.84514,-4.66805 -0.8346,-0.818421 -1.76455,-1.329266 -2.96095,-1.626534 -0.46506,-0.115667 -0.56674,-0.124917 -1.36408,-0.124917 -0.7976,0 -0.89861,0.0092 -1.36409,0.124917 -2.38863,0.593503 -4.07675,2.280354 -4.67008,4.666658 -0.11501,0.463336 -0.12501,0.567253 -0.12418,1.340991 5e-4,0.71242 0.0167,0.948413 0.12335,1.5671 0.31754,1.878935 0.97587,4.408181 1.78597,6.86432 1.17331,3.557435 2.70917,6.834136 3.72271,7.942108 0.40838,0.44642 0.5359,0.485336 0.82177,0.250668 z M 135.53696,36.40441 c -0.075,-0.01167 -0.30171,-0.07167 -0.50757,-0.133584 -0.63341,-0.190084 -1.08905,-0.480253 -1.57669,-1.00343 -0.37921,-0.406669 -0.59674,-0.773588 -0.77426,-1.306949 -0.13085,-0.393585 -0.14002,-0.458752 -0.14002,-1.059439 0,-0.600503 0.008,-0.666087 0.14002,-1.060756 0.37004,-1.113964 1.21923,-1.952135 2.3507,-2.320337 0.34005,-0.110584 0.43672,-0.122251 1.01605,-0.122501 0.60174,-3.33e-4 0.66591,0.0082 1.06021,0.139335 0.53507,0.178084 0.90103,0.394835 1.31233,0.77767 0.5259,0.489503 0.80093,0.923164 1.01454,1.601126 0.10918,0.345668 0.12252,0.456669 0.12252,0.98548 0,0.528836 -0.0167,0.639753 -0.12252,0.98548 -0.20669,0.655253 -0.47839,1.094156 -0.96337,1.5553 -0.67925,0.64642 -1.37067,0.93818 -2.2912,0.967363 -0.2792,0.0092 -0.56757,0.0067 -0.64091,-0.0048 z m 1.22481,-1.90206 c 0.40755,-0.190501 0.66425,-0.441586 0.86328,-0.843805 0.15585,-0.315251 0.16502,-0.356918 0.16502,-0.757504 0,-0.400585 -0.008,-0.442335 -0.16502,-0.757504 -0.19919,-0.401752 -0.45423,-0.652003 -0.86528,-0.846454 -0.2667,-0.126334 -0.33504,-0.139668 -0.71508,-0.139668 -0.37922,0 -0.44756,0.01333 -0.71509,0.139668 -0.41089,0.194418 -0.66675,0.444669 -0.86519,0.846454 -0.15586,0.314835 -0.16502,0.357252 -0.16502,0.755254 0,0.381086 0.0167,0.449753 0.13835,0.714004 0.23336,0.49267 0.5634,0.786338 1.0978,0.977197 0.34588,0.123584 0.85102,0.08742 1.22532,-0.08758 z m -3.35824,14.853179 c -0.88686,-1.446241 -1.68063,-3.061091 -2.21861,-4.513674 -0.0417,-0.121417 -0.14419,-0.379669 -0.22003,-0.573836 -0.20919,-0.536253 -0.55507,-1.508625 -0.8151,-2.295463 -0.21252,-0.642086 -0.3142,-0.964088 -0.66258,-2.088061 -0.0583,-0.201584 -0.11335,-0.395835 -0.11335,-0.431752 0,-0.175834 -0.29003,-0.0885 -1.25907,0.379752 -3.58869,1.733593 -4.55281,4.317756 -2.43388,6.523551 1.1048,1.150148 2.86927,2.061553 5.1783,2.67484 0.8276,0.219834 2.05084,0.449752 2.46181,0.462835 l 0.17002,0.0054 z m 5.76379,0.09717 c 1.74663,-0.234251 3.84414,-0.880846 5.18289,-1.597808 1.62262,-0.868963 2.60907,-1.850993 3.02687,-3.013333 0.11419,-0.317252 0.12669,-0.408419 0.12669,-0.904613 8e-5,-0.466836 -0.0167,-0.596003 -0.10335,-0.83873 -0.47256,-1.31439 -1.5882,-2.377904 -3.42609,-3.265759 -0.9692,-0.468169 -1.25907,-0.555586 -1.25907,-0.379752 0,0.03583 -0.05,0.230252 -0.11335,0.431753 -0.34754,1.123972 -0.45005,1.445999 -0.66258,2.088061 -0.26003,0.786837 -0.60507,1.759234 -0.8151,2.295462 -0.075,0.194251 -0.17502,0.452502 -0.22003,0.573836 -0.53756,1.452583 -1.33175,3.067433 -2.2186,4.513674 l -0.0884,0.143501 h 0.11168 c 0.0583,0 0.2667,-0.02083 0.45672,-0.04667 z"
      />
    </svg>
  );
};

const HomeHeartIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentcolor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m12.223 11.641-.223.22-.224-.22a2.224 2.224 0 0 0-3.125 0 2.13 2.13 0 0 0 0 3.07L12 18l3.349-3.289a2.13 2.13 0 0 0 0-3.07 2.225 2.225 0 0 0-3.126 0z" />
      <path d="m21.707 11.293-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707zM18.001 20H6v-9.585l6-6 6 6V15l.001 5z" />
    </svg>
  );
};
const HomePhoneIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 19V10.5C20 10.1852 19.8518 9.88885 19.6 9.7L12.6 4.45C12.2444 4.18333 11.7556 4.18333 11.4 4.45L4.4 9.7C4.14819 9.88885 4 10.1852 4 10.5V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 19.5523 10 19V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V19C14 19.5523 14.4477 20 15 20H19C19.5523 20 20 19.5523 20 19Z"
        stroke="currentcolor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

const InfoIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
        fill="currentColor"
      />
    </svg>
  );
};

const DeleteIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      version="1.2"
      baseProfile="tiny"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 4c-4.419 0-8 3.582-8 8s3.581 8 8 8 8-3.582 8-8-3.581-8-8-8zm3.707 10.293c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-2.293-2.293-2.293 2.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l2.293-2.293-2.293-2.293c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l2.293 2.293 2.293-2.293c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-2.293 2.293 2.293 2.293z" />
    </svg>
  );
};
const DetailsIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 -0.5 11 11"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Details"
          transform="translate(-304.000000, -565.000000)"
          fill="currentColor"
        >
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path
              d="M259,410 C259,410.552 258.5072,411 257.9,411 L256.1554,411 L257.3896,412.121 C257.8186,412.512 257.8186,413.145 257.3896,413.536 L257.3896,413.536 C256.9595,413.926 256.2632,413.926 255.8331,413.536 L254.6,412.414 L254.6,414 C254.6,414.552 254.1072,415 253.5,415 L253.5,415 C252.8928,415 252.4,414.552 252.4,414 L252.4,412.414 L251.1669,413.536 C250.7368,413.926 250.0405,413.926 249.6104,413.536 C249.1814,413.145 249.1814,412.512 249.6104,412.121 L250.8446,411 L249.1,411 C248.4928,411 248,410.552 248,410 L248,410 C248,409.448 248.4928,409 249.1,409 L250.8446,409 L249.6104,407.879 C249.1814,407.488 249.1814,406.855 249.6104,406.464 L249.6104,406.464 C250.0405,406.074 250.7368,406.074 251.1669,406.464 L252.4,407.586 L252.4,406 C252.4,405.448 252.8928,405 253.5,405 L253.5,405 C254.1072,405 254.6,405.448 254.6,406 L254.6,407.586 L255.8331,406.464 C256.2632,406.074 256.9595,406.074 257.3896,406.464 L257.3896,406.464 C257.8186,406.855 257.8186,407.488 257.3896,407.879 L256.1554,409 L257.9,409 C258.5072,409 259,409.448 259,410 L259,410 Z"
              id="svgdetails"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

const HamburgerIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="presentation"
      className={`w-${width} h-${height}`}
    >
      <g fill="none" fillRule="nonzero">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m2 16h28"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m2 24h28"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m2 8h28"
        ></path>
      </g>
    </svg>
  );
};

const HelpIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7.92 9.234v.102a.5.5 0 0 0 .5.5h.997a.499.499 0 0 0 .499-.499c0-1.29.998-1.979 2.34-1.979 1.308 0 2.168.689 2.168 1.67 0 .928-.482 1.359-1.686 1.91l-.344.154C11.379 11.54 11 12.21 11 13.381v.119a.5.5 0 0 0 .5.5h.997a.499.499 0 0 0 .499-.499c0-.516.138-.723.55-.912l.345-.155c1.445-.654 2.529-1.514 2.529-3.39v-.103c0-1.978-1.72-3.441-4.164-3.441-2.478 0-4.336 1.428-4.336 3.734zm2.58 7.757c0 .867.659 1.509 1.491 1.509.85 0 1.509-.642 1.509-1.509 0-.867-.659-1.491-1.509-1.491-.832 0-1.491.624-1.491 1.491z"
        fill="currentColor"
      />
    </svg>
  );
};

const ImageIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.205 3h11.59c1.114 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926v7.51l-4.391-4.053a1.5 1.5 0 0 0-2.265.27l-3.13 4.695-2.303-1.48a1.5 1.5 0 0 0-1.96.298L3.005 18.15A12.98 12.98 0 0 1 3 17.795V6.205c0-1.115.116-1.519.334-1.926.218-.407.538-.727.945-.945C4.686 3.116 5.09 3 6.205 3zm9.477 8.53L21 16.437v1.357c0 1.114-.116 1.519-.334 1.926a2.272 2.272 0 0 1-.945.945c-.407.218-.811.334-1.926.334H6.205c-1.115 0-1.519-.116-1.926-.334a2.305 2.305 0 0 1-.485-.345L8.2 15.067l2.346 1.508a1.5 1.5 0 0 0 2.059-.43l3.077-4.616zM7.988 6C6.878 6 6 6.832 6 7.988 6 9.145 6.879 10 7.988 10 9.121 10 10 9.145 10 7.988 10 6.832 9.121 6 7.988 6z"
        fill="currentColor"
      />
    </svg>
  );
};
const ListIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 6L21 6.00078M8 12L21 12.0008M8 18L21 18.0007M3 6.5H4V5.5H3V6.5ZM3 12.5H4V11.5H3V12.5ZM3 18.5H4V17.5H3V18.5Z"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const LinkIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16488 17.6505C8.92513 17.8743 8.73958 18.0241 8.54996 18.1336C7.62175 18.6695 6.47816 18.6695 5.54996 18.1336C5.20791 17.9361 4.87912 17.6073 4.22153 16.9498C3.56394 16.2922 3.23514 15.9634 3.03767 15.6213C2.50177 14.6931 2.50177 13.5495 3.03767 12.6213C3.23514 12.2793 3.56394 11.9505 4.22153 11.2929L7.04996 8.46448C7.70755 7.80689 8.03634 7.47809 8.37838 7.28062C9.30659 6.74472 10.4502 6.74472 11.3784 7.28061C11.7204 7.47809 12.0492 7.80689 12.7068 8.46448C13.3644 9.12207 13.6932 9.45086 13.8907 9.7929C14.4266 10.7211 14.4266 11.8647 13.8907 12.7929C13.7812 12.9825 13.6314 13.1681 13.4075 13.4078M10.5919 10.5922C10.368 10.8319 10.2182 11.0175 10.1087 11.2071C9.57284 12.1353 9.57284 13.2789 10.1087 14.2071C10.3062 14.5492 10.635 14.878 11.2926 15.5355C11.9502 16.1931 12.279 16.5219 12.621 16.7194C13.5492 17.2553 14.6928 17.2553 15.621 16.7194C15.9631 16.5219 16.2919 16.1931 16.9495 15.5355L19.7779 12.7071C20.4355 12.0495 20.7643 11.7207 20.9617 11.3787C21.4976 10.4505 21.4976 9.30689 20.9617 8.37869C20.7643 8.03665 20.4355 7.70785 19.7779 7.05026C19.1203 6.39267 18.7915 6.06388 18.4495 5.8664C17.5212 5.3305 16.3777 5.3305 15.4495 5.8664C15.2598 5.97588 15.0743 6.12571 14.8345 6.34955"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
const LoadingErrorIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <path
              d="M402.728,328.759l-128-234.667c-8.086-14.824-29.371-14.824-37.457,0l-128,234.667
				c-7.754,14.216,2.535,31.549,18.728,31.549h256C400.193,360.308,410.483,342.975,402.728,328.759z M163.937,317.641L256,148.859
				l92.063,168.782H163.937z"
            />
            <path
              d="M256,18.975c-141.382,0-256,114.618-256,256c0,63.028,26.79,123.549,71.037,170.667H64
				c-11.782,0-21.333,9.551-21.333,21.333c0,11.782,9.551,21.333,21.333,21.333h64c0.224,0,0.442-0.027,0.664-0.034
				c0.411-0.013,0.822-0.025,1.231-0.062c0.35-0.031,0.694-0.082,1.039-0.129c0.331-0.046,0.662-0.09,0.991-0.151
				c0.385-0.072,0.763-0.162,1.14-0.254c0.288-0.07,0.576-0.139,0.862-0.222c0.381-0.11,0.754-0.236,1.126-0.367
				c0.284-0.099,0.567-0.199,0.847-0.31c0.345-0.138,0.683-0.289,1.019-0.444c0.302-0.139,0.603-0.28,0.899-0.433
				c0.295-0.154,0.583-0.318,0.87-0.485c0.321-0.186,0.639-0.374,0.95-0.577c0.252-0.165,0.497-0.339,0.742-0.514
				c0.321-0.229,0.639-0.461,0.948-0.709c0.231-0.186,0.453-0.381,0.676-0.576c0.293-0.256,0.585-0.513,0.865-0.786
				c0.239-0.233,0.465-0.478,0.694-0.722c0.238-0.255,0.478-0.507,0.705-0.776c0.266-0.313,0.512-0.641,0.759-0.97
				c0.134-0.178,0.281-0.341,0.411-0.524c0.036-0.052,0.064-0.106,0.1-0.158c0.263-0.379,0.502-0.775,0.74-1.172
				c0.127-0.211,0.264-0.417,0.383-0.63c0.216-0.389,0.404-0.793,0.596-1.196c0.112-0.236,0.237-0.468,0.34-0.706
				c0.153-0.356,0.279-0.725,0.413-1.09c0.109-0.297,0.231-0.59,0.326-0.89c0.094-0.298,0.164-0.607,0.245-0.911
				c0.101-0.377,0.211-0.753,0.291-1.133c0.053-0.253,0.084-0.513,0.128-0.77c0.076-0.441,0.154-0.881,0.202-1.325
				c0.026-0.242,0.032-0.488,0.05-0.732c0.034-0.463,0.067-0.925,0.07-1.387c0.001-0.063,0.009-0.124,0.009-0.187v-64
				c0-11.782-9.551-21.333-21.333-21.333c-11.782,0-21.333,9.551-21.333,21.333v18.119c-39.846-40.249-64-92.525-64-146.119
				c0-117.818,95.515-213.333,213.333-213.333s213.333,95.515,213.333,213.333c0,72.999-36.944,139.688-96.987,178.846
				c-9.869,6.436-12.652,19.654-6.216,29.523c6.436,9.869,19.654,12.652,29.523,6.216C467.65,442.606,512,362.546,512,274.975
				C512,133.593,397.382,18.975,256,18.975z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
const LotusFlowerIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.063,8.226a7.976,7.976,0,0,0-5.521.63,10.063,10.063,0,0,0-3.986-5.687,1,1,0,0,0-1.112,0A10.072,10.072,0,0,0,7.457,8.858a7.964,7.964,0,0,0-5.521-.632,1,1,0,0,0-.732.769,10.771,10.771,0,0,0,2.481,9.149C6.036,20.781,8.873,21,11.816,21h.356c2.947,0,5.786-.219,8.14-2.855A10.764,10.764,0,0,0,22.8,8.994,1,1,0,0,0,22.063,8.226ZM12,5.245a8.36,8.36,0,0,1,2.772,4.73,9.256,9.256,0,0,0-1.089,1.017A10.3,10.3,0,0,0,12,13.515a10.345,10.345,0,0,0-1.687-2.523A9.314,9.314,0,0,0,9.227,9.98,8.362,8.362,0,0,1,12,5.245ZM10.958,18.992c-2.272-.05-4.173-.376-5.78-2.179A8.762,8.762,0,0,1,3.06,10.04a6.63,6.63,0,0,1,5.762,2.341A8.768,8.768,0,0,1,10.958,18.992Zm7.861-2.179c-1.61,1.8-3.513,2.129-5.789,2.179a8.759,8.759,0,0,1,2.138-6.61,6.808,6.808,0,0,1,5.011-2.393,5.528,5.528,0,0,1,.761.052A8.755,8.755,0,0,1,18.819,16.813Z" />
    </svg>
  );
};
const MapPinIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.37892 10.2236L8 16L12.6211 10.2236C13.5137 9.10788 14 7.72154 14 6.29266V6C14 2.68629 11.3137 0 8 0C4.68629 0 2 2.68629 2 6V6.29266C2 7.72154 2.4863 9.10788 3.37892 10.2236ZM8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z"
        fill="currentColor"
      />
    </svg>
  );
};

const MenuGridIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="MenuGrid">
        <g id="Vector">
          <path
            d="M14 15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14C14.4477 14 14 14.4477 14 15Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 15C8 15.5523 8.44772 16 9 16C9.55228 16 10 15.5523 10 15C10 14.4477 9.55228 14 9 14C8.44772 14 8 14.4477 8 15Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 9C14 9.55228 14.4477 10 15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 9C8 9.55228 8.44772 10 9 10C9.55228 10 10 9.55228 10 9C10 8.44772 9.55228 8 9 8C8.44772 8 8 8.44772 8 9Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

const MessagesIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 18"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16 5h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2v3l-4-3H8m4-13H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2v3l4-3h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Z"
      />
    </svg>
  );
};
const MessagesOffIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.28034 2.21968C2.98745 1.92678 2.51257 1.92677 2.21968 2.21966C1.92678 2.51255 1.92677 2.98743 2.21966 3.28032L4.41838 5.47908C2.91114 7.2299 2 9.50855 2 12C2 13.6203 2.38637 15.186 3.11461 16.5922L2.04695 20.4151C1.98549 20.6349 1.98546 20.8676 2.04691 21.0876C2.23258 21.7525 2.92212 22.141 3.58704 21.9553L7.41286 20.888C8.81782 21.6146 10.3817 22 12 22C14.4914 22 16.77 21.0889 18.5208 19.5818L20.7194 21.7805C21.0123 22.0734 21.4872 22.0734 21.7801 21.7805C22.073 21.4876 22.073 21.0127 21.7801 20.7198L3.28034 2.21968ZM17.4566 18.5176C15.9802 19.755 14.0771 20.5 12 20.5C10.5322 20.5 9.12006 20.1281 7.86709 19.4295L7.59755 19.2792L3.61096 20.3914L4.72368 16.4073L4.57303 16.1375C3.87277 14.8834 3.5 13.4696 3.5 12C3.5 9.92285 4.24507 8.01971 5.48254 6.54326L8.48673 9.54752C8.20238 9.65413 8 9.92843 8 10.25C8 10.6642 8.33579 11 8.75 11H9.93919L11.9392 13H8.75L8.64823 13.0069C8.28215 13.0565 8 13.3703 8 13.75C8 14.1642 8.33579 14.5 8.75 14.5H13.2483L13.35 14.4932C13.3735 14.49 13.3967 14.4857 13.4195 14.4804L17.4566 18.5176Z"
        fill="currentColor"
      />
      <path
        d="M15.2545 9.50001H12.6818L14.1818 11H15.2545L15.3563 10.9932C15.7223 10.9435 16.0045 10.6297 16.0045 10.25C16.0045 9.83579 15.6687 9.50001 15.2545 9.50001Z"
        fill="currentColor"
      />
      <path
        d="M20.5 12C20.5 13.5302 20.0957 14.966 19.388 16.2063L20.4816 17.2999C21.4438 15.7634 22 13.9466 22 12C22 6.47716 17.5228 2.00001 12 2.00001C10.0534 2.00001 8.23677 2.55619 6.70025 3.5183L7.79388 4.61195C9.03415 3.90432 10.4699 3.50001 12 3.50001C16.6944 3.50001 20.5 7.30559 20.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
};

const MicrophoneIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.69231 10.3721C4.07466 10.3721 4.38462 10.6845 4.38462 11.0698V12.9302C4.38462 17.1687 7.79414 20.6047 12 20.6047C16.2059 20.6047 19.6154 17.1687 19.6154 12.9302V11.0698C19.6154 10.6845 19.9253 10.3721 20.3077 10.3721C20.69 10.3721 21 10.6845 21 11.0698V12.9302C21 17.9393 16.9706 22 12 22C7.02944 22 3 17.9393 3 12.9302V11.0698C3 10.6845 3.30996 10.3721 3.69231 10.3721Z"
        fill="currentcolor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C8.55884 2 5.76923 4.81123 5.76923 8.27907V12.9302C5.76923 16.3981 8.55884 19.2093 12 19.2093C15.4412 19.2093 18.2308 16.3981 18.2308 12.9302V8.27907C18.2308 4.81124 15.4412 2 12 2ZM9.67822 7.39068C9.40039 7.12597 9.3881 6.6844 9.65078 6.40441L10.1538 6.88372C9.65078 6.40441 9.65154 6.40361 9.65154 6.40361L9.65231 6.40279L9.65388 6.40114L9.65716 6.3977L9.66431 6.39036C9.66934 6.38527 9.67489 6.37977 9.68099 6.37391C9.69318 6.36218 9.70751 6.349 9.72413 6.33461C9.75739 6.3058 9.79962 6.27232 9.85184 6.23613C9.95658 6.16357 10.0997 6.0814 10.2887 6.00438C10.6676 5.84997 11.2189 5.72093 12 5.72093C12.7811 5.72093 13.3324 5.84997 13.7113 6.00438C13.9003 6.0814 14.0434 6.16357 14.1482 6.23613C14.2004 6.27232 14.2426 6.3058 14.2759 6.33461C14.2925 6.349 14.3068 6.36218 14.319 6.37391C14.3251 6.37977 14.3307 6.38527 14.3357 6.39036L14.3428 6.3977L14.3461 6.40114L14.3477 6.40279L14.3485 6.40361C14.3485 6.40361 14.3492 6.40441 13.8562 6.87412L14.3492 6.40441C14.6119 6.6844 14.5996 7.12597 14.3218 7.39068C14.0536 7.64624 13.6359 7.64354 13.371 7.39112L13.3637 7.38596C13.3426 7.37132 13.2885 7.33721 13.1922 7.29795C13.0004 7.2198 12.6287 7.11628 12 7.11628C11.3713 7.11628 10.9996 7.2198 10.8078 7.29795C10.7115 7.33721 10.6574 7.37132 10.6363 7.38596L10.629 7.39112C10.3641 7.64354 9.94645 7.64624 9.67822 7.39068ZM9.67822 10.1814C9.40039 9.91667 9.3881 9.4751 9.65078 9.19511L10.1538 9.67442C9.65078 9.19511 9.65154 9.19431 9.65154 9.19431L9.65231 9.19349L9.65388 9.19183L9.65716 9.1884L9.66431 9.18106C9.66934 9.17597 9.67489 9.17047 9.68099 9.16461C9.69318 9.15288 9.70751 9.13969 9.72413 9.1253C9.75739 9.0965 9.79962 9.06301 9.85184 9.02683C9.95658 8.95427 10.0997 8.8721 10.2887 8.79507C10.6676 8.64067 11.2189 8.51163 12 8.51163C12.7811 8.51163 13.3324 8.64067 13.7113 8.79507C13.9003 8.8721 14.0434 8.95427 14.1482 9.02683C14.2004 9.06301 14.2426 9.0965 14.2759 9.1253C14.2925 9.13969 14.3068 9.15288 14.319 9.16461C14.3251 9.17047 14.3307 9.17597 14.3357 9.18106L14.3428 9.1884L14.3461 9.19183L14.3477 9.19349L14.3485 9.19431C14.3485 9.19431 14.3492 9.1951 13.8562 9.66482L14.3492 9.19511C14.6119 9.4751 14.5996 9.91667 14.3218 10.1814C14.0536 10.4369 13.6359 10.4342 13.371 10.1818L13.3637 10.1767C13.3426 10.162 13.2885 10.1279 13.1922 10.0886C13.0004 10.0105 12.6287 9.90698 12 9.90698C11.3713 9.90698 10.9996 10.0105 10.8078 10.0886C10.7115 10.1279 10.6574 10.162 10.6363 10.1767L10.629 10.1818C10.3641 10.4342 9.94645 10.4369 9.67822 10.1814Z"
        fill="currentcolor"
      />
    </svg>
  );
};

const MicrophoneOffIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="-3.5 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="page1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="filled"
          transform="translate(-156.000000, -309.000000)"
          fill="currentColor"
        >
          <path d="M169,335 C167.061,335 165.236,334.362 163.716,333.318 L162.31,334.742 C163.944,335.953 165.892,336.765 168,336.955 L168,339 L167,339 C166.448,339 166,339.448 166,340 C166,340.553 166.448,341 167,341 L171,341 C171.552,341 172,340.553 172,340 C172,339.448 171.552,339 171,339 L170,339 L170,336.955 C174.938,336.51 179.117,332.799 180,328 L178,328 C177.089,332.007 173.282,335 169,335 L169,335 Z M176,326 L176,320.739 L164.735,331.515 C165.918,332.432 167.386,333 169,333 C172.866,333 176,329.866 176,326 L176,326 Z M160.047,328.145 L160,328 L158,328 C158.109,328.596 158.271,329.175 158.478,329.733 L160.047,328.145 L160.047,328.145 Z M179.577,312.013 L155.99,334.597 L157.418,336.005 L181.014,313.433 L179.577,312.013 L179.577,312.013 Z M169,309 C165.134,309 162,312.134 162,316 L161.997,326.309 L175.489,313.401 C174.456,310.825 171.946,309 169,309 L169,309 Z"></path>
        </g>
      </g>
    </svg>
  );
};

const MicrophoneHandIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentcolor"
      id="microphone"
      xmlns="http://www.w3.org/2000/svg"
      className={`w-${width} h-${height}`}
      viewBox="0 0 310.157 310.156"
    >
      <g>
        <g>
          <path
            d="M266.177,177.269c-0.172-15.678-11.021-19.927-24.207-19.82l-65.899,0.012c-2.91-6.404-5.83-18.135-14.242-24.815
			c-14.98-11.895-27.469-6.413-36.887-0.785c-21.281,12.704-45.342,39.316-59.986,44.25c-18.006,6.066-39.805,4.485-39.805,4.485
			v91.684c37.328,0,60.121,13.122,79.125,20.917c43.066,17.662,73.182,17.357,88.932,16.772c32.658-1.215,35.4-27.871,36.285-33.175
			c8.477-3.372,14.047-8.527,16.602-15.342c0.998-2.656,1.505-5.561,1.505-8.605c0-5.12-1.406-9.727-2.656-12.816
			c7.424-4.092,12.028-9.552,13.707-16.24c0.467-1.837,0.676-3.779,0.701-5.774c0.151-13.562-6.673-16.868-6.673-16.868
			S266.351,192.948,266.177,177.269z"
          />
          <path
            d="M254.375,5.027l-15.627-3.849c-21.584-5.317-43.39,7.869-48.707,29.453l-1.006,4.087L282.82,57.82l1.008-4.086
			C289.144,32.152,275.96,10.345,254.375,5.027z"
          />
          <path
            d="M181.139,66.775c-3.375,13.702,0.713,27.485,9.666,37.092l-7.265,40.098h57.525l8.067-25.729
			c12.392-4.347,22.414-14.657,25.789-28.358l4.152-16.859L185.29,49.916L181.139,66.775z"
          />
        </g>
      </g>
    </svg>
  );
};
const MindBlownIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 15C10.5304 15 11.0391 15.2107 11.4142 15.5858C11.7893 15.9609 12 16.4696 12 17H8C8 16.4696 8.21071 15.9609 8.58579 15.5858C8.96086 15.2107 9.46957 15 10 15Z"
        fill="currentColor"
      />
      <path
        d="M11.815 7H14.5C14.8094 7.00187 15.1149 6.93196 15.3927 6.79576C15.6704 6.65956 15.9128 6.46078 16.1007 6.21505C16.2887 5.96933 16.4171 5.68335 16.4758 5.37962C16.5345 5.07589 16.5219 4.76267 16.4391 4.46461C16.3563 4.16655 16.2055 3.89176 15.9985 3.66185C15.7915 3.43194 15.534 3.25319 15.2462 3.13963C14.9585 3.02608 14.6483 2.98083 14.3401 3.00745C14.0319 3.03406 13.734 3.1318 13.47 3.293C13.4877 3.19627 13.4977 3.0983 13.5 3C13.5017 2.59284 13.3787 2.19493 13.1474 1.85985C12.916 1.52478 12.5876 1.26863 12.2063 1.12591C11.825 0.983182 11.4091 0.960736 11.0146 1.06159C10.6201 1.16245 10.266 1.38176 10 1.69C9.73397 1.38176 9.37988 1.16245 8.98541 1.06159C8.59094 0.960736 8.17504 0.983182 7.79371 1.12591C7.41239 1.26863 7.08396 1.52478 6.85265 1.85985C6.62134 2.19493 6.49827 2.59284 6.5 3C6.50231 3.0983 6.51234 3.19627 6.53 3.293C6.26596 3.1318 5.96812 3.03406 5.65991 3.00745C5.35171 2.98083 5.04152 3.02608 4.75376 3.13963C4.466 3.25319 4.2085 3.43194 4.00151 3.66185C3.79453 3.89176 3.64369 4.16655 3.56088 4.46461C3.47806 4.76267 3.46551 5.07589 3.52423 5.37962C3.58294 5.68335 3.71131 5.96933 3.89925 6.21505C4.08719 6.46078 4.32956 6.65956 4.60732 6.79576C4.88508 6.93196 5.19065 7.00187 5.5 7H8.888M11.815 6.01499V9.24299M8.228 6.99999V9.27999M18.972 9.574C18.8671 9.95502 18.6401 10.2911 18.3258 10.5306C18.0114 10.7702 17.6272 10.8999 17.232 10.9C16.8281 10.9012 16.4345 10.7731 16.1086 10.5346C15.7828 10.296 15.5418 9.95937 15.421 9.574C15.2987 9.95819 15.0574 10.2935 14.7319 10.5315C14.4064 10.7695 14.0137 10.8977 13.6105 10.8977C13.2073 10.8977 12.8146 10.7695 12.4891 10.5315C12.1636 10.2935 11.9223 9.95819 11.8 9.574C11.6955 9.95694 11.4673 10.2946 11.151 10.5344C10.8347 10.7742 10.4479 10.9028 10.051 10.9C9.64027 10.9002 9.23963 10.7727 8.90458 10.5351C8.56954 10.2976 8.31667 9.96167 8.181 9.574C8.08341 9.95546 7.86093 10.2933 7.54902 10.5336C7.23712 10.7739 6.85374 10.9029 6.46 10.9C6.04517 10.8995 5.64039 10.7722 5.29992 10.5352C4.95944 10.2982 4.69953 9.96284 4.555 9.574C4.43288 9.95935 4.19103 10.2957 3.86462 10.5342C3.53821 10.7727 3.14424 10.9008 2.74 10.9C2.3448 10.8999 1.96055 10.7702 1.64623 10.5306C1.3319 10.2911 1.10487 9.95502 1 9.574V10C1 12.3869 1.94821 14.6761 3.63604 16.364C5.32387 18.0518 7.61305 19 10 19C12.3869 19 14.6761 18.0518 16.364 16.364C18.0518 14.6761 19 12.3869 19 10L18.972 9.574Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14.5C8.05228 14.5 8.5 14.0523 8.5 13.5C8.5 12.9477 8.05228 12.5 7.5 12.5C6.94772 12.5 6.5 12.9477 6.5 13.5C6.5 14.0523 6.94772 14.5 7.5 14.5Z"
        fill="currentColor"
      />
      <path
        d="M12.5 14.5C13.0523 14.5 13.5 14.0523 13.5 13.5C13.5 12.9477 13.0523 12.5 12.5 12.5C11.9477 12.5 11.5 12.9477 11.5 13.5C11.5 14.0523 11.9477 14.5 12.5 14.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
const MinimizeIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9425 1.25H12.0573C14.3657 1.24999 16.1747 1.24998 17.5862 1.43975C19.0309 1.63399 20.171 2.03933 21.0658 2.93414C21.9606 3.82895 22.3659 4.96897 22.5602 6.41371C22.7499 7.82519 22.7499 9.63423 22.7499 11.9426V12.0574C22.7499 14.3658 22.7499 16.1748 22.5602 17.5863C22.3659 19.031 21.9606 20.1711 21.0658 21.0659C20.2374 21.8943 19.198 22.3038 17.8993 22.514C16.6225 22.7207 15.0164 22.7458 13.0013 22.7494C12.5871 22.7502 12.2507 22.415 12.2499 22.0008C12.2492 21.5866 12.5843 21.2502 12.9986 21.2494C15.0385 21.2457 16.5216 21.2175 17.6596 21.0333C18.7756 20.8526 19.4765 20.5338 20.0051 20.0052C20.5748 19.4355 20.9017 18.6648 21.0735 17.3864C21.2483 16.0864 21.2499 14.3782 21.2499 12C21.2499 9.62178 21.2483 7.91356 21.0735 6.61358C20.9017 5.33517 20.5748 4.56445 20.0051 3.9948C19.4355 3.42514 18.6647 3.09825 17.3863 2.92637C16.0864 2.75159 14.3781 2.75 11.9999 2.75C9.62169 2.75 7.91347 2.75159 6.61349 2.92637C5.33509 3.09825 4.56437 3.42514 3.99471 3.9948C3.46609 4.52341 3.1473 5.22427 2.96665 6.34031C2.78246 7.47827 2.75416 8.96143 2.75049 11.0014C2.74974 11.4156 2.41335 11.7507 1.99914 11.75C1.58493 11.7493 1.24975 11.4129 1.25049 10.9986C1.25412 8.9835 1.27926 7.37741 1.48592 6.10063C1.69614 4.80193 2.10563 3.76255 2.93405 2.93414C3.82886 2.03933 4.96888 1.63399 6.41362 1.43975C7.82511 1.24998 9.63414 1.24999 11.9425 1.25Z"
        fill="currentColor"
      />
      <path
        d="M16.5 12C16.5 12.4142 16.1642 12.75 15.75 12.75H12C11.5858 12.75 11.25 12.4142 11.25 12V8.25C11.25 7.83579 11.5858 7.5 12 7.5C12.4142 7.5 12.75 7.83579 12.75 8.25V10.1893L16.4697 6.46967C16.7626 6.17678 17.2374 6.17678 17.5303 6.46967C17.8232 6.76256 17.8232 7.23744 17.5303 7.53033L13.8107 11.25H15.75C16.1642 11.25 16.5 11.5858 16.5 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.948 13.25C5.04952 13.25 4.3003 13.2499 3.70552 13.3299C3.07773 13.4143 2.51093 13.6 2.05546 14.0555C1.59999 14.5109 1.41432 15.0777 1.32991 15.7055C1.24995 16.3003 1.24997 17.0495 1.25 17.948V18.052C1.24997 18.9505 1.24995 19.6997 1.32991 20.2945C1.41432 20.9223 1.59999 21.4891 2.05546 21.9445C2.51093 22.4 3.07773 22.5857 3.70552 22.6701C4.3003 22.7501 5.04951 22.75 5.94798 22.75H6.052C6.95047 22.75 7.69971 22.7501 8.29448 22.6701C8.92228 22.5857 9.48908 22.4 9.94455 21.9445C10.4 21.4891 10.5857 20.9223 10.6701 20.2945C10.7501 19.6997 10.75 18.9505 10.75 18.052V17.948C10.75 17.0495 10.7501 16.3003 10.6701 15.7055C10.5857 15.0777 10.4 14.5109 9.94455 14.0555C9.48908 13.6 8.92228 13.4143 8.29448 13.3299C7.6997 13.2499 6.95048 13.25 6.052 13.25H5.948ZM3.11612 15.1161C3.24644 14.9858 3.44393 14.8786 3.9054 14.8165C4.38843 14.7516 5.03599 14.75 6 14.75C6.96401 14.75 7.61157 14.7516 8.09461 14.8165C8.55607 14.8786 8.75357 14.9858 8.88389 15.1161C9.0142 15.2464 9.12143 15.4439 9.18347 15.9054C9.24841 16.3884 9.25 17.036 9.25 18C9.25 18.964 9.24841 19.6116 9.18347 20.0946C9.12143 20.5561 9.0142 20.7536 8.88389 20.8839C8.75357 21.0142 8.55607 21.1214 8.09461 21.1835C7.61157 21.2484 6.96401 21.25 6 21.25C5.03599 21.25 4.38843 21.2484 3.9054 21.1835C3.44393 21.1214 3.24644 21.0142 3.11612 20.8839C2.9858 20.7536 2.87858 20.5561 2.81654 20.0946C2.7516 19.6116 2.75 18.964 2.75 18C2.75 17.036 2.7516 16.3884 2.81654 15.9054C2.87858 15.4439 2.9858 15.2464 3.11612 15.1161Z"
        fill="currentColor"
      />
    </svg>
  );
};
const MinusIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C10.22 21 8.47991 20.4722 6.99987 19.4832C5.51983 18.4943 4.36628 17.0887 3.68509 15.4442C3.0039 13.7996 2.82567 11.99 3.17294 10.2442C3.5202 8.49836 4.37737 6.89472 5.63604 5.63604C6.89472 4.37737 8.49836 3.5202 10.2442 3.17294C11.99 2.82567 13.7996 3.0039 15.4442 3.68509C17.0887 4.36628 18.4943 5.51983 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C21 14.387 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.387 21 12 21ZM12 4.5C10.5166 4.5 9.0666 4.93987 7.83323 5.76398C6.59986 6.58809 5.63856 7.75943 5.07091 9.12988C4.50325 10.5003 4.35473 12.0083 4.64411 13.4632C4.9335 14.918 5.64781 16.2544 6.6967 17.3033C7.7456 18.3522 9.08197 19.0665 10.5368 19.3559C11.9917 19.6453 13.4997 19.4968 14.8701 18.9291C16.2406 18.3614 17.4119 17.4001 18.236 16.1668C19.0601 14.9334 19.5 13.4834 19.5 12C19.5 10.0109 18.7098 8.10323 17.3033 6.6967C15.8968 5.29018 13.9891 4.5 12 4.5Z"
        fill="currentColor"
      />
      <path
        d="M16 12.75H8C7.80109 12.75 7.61032 12.671 7.46967 12.5303C7.32902 12.3897 7.25 12.1989 7.25 12C7.25 11.8011 7.32902 11.6103 7.46967 11.4697C7.61032 11.329 7.80109 11.25 8 11.25H16C16.1989 11.25 16.3897 11.329 16.5303 11.4697C16.671 11.6103 16.75 11.8011 16.75 12C16.75 12.1989 16.671 12.3897 16.5303 12.5303C16.3897 12.671 16.1989 12.75 16 12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

const MusicEigthNotesIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 16V3.36611C22 2.12848 20.8873 1.18793 19.6669 1.39403L8.66694 3.25181C7.70452 3.41435 7 4.24784 7 5.22388V14.126C6.68038 14.0438 6.3453 14 6 14C3.79086 14 2 15.7909 2 18C2 20.2091 3.79086 22 6 22C8.20914 22 10 20.2091 10 18V6.06916L19 4.54916V12.126C18.6804 12.0438 18.3453 12 18 12C15.7909 12 14 13.7909 14 16C14 18.2091 15.7909 20 18 20C20.2091 20 22 18.2091 22 16Z"
        fill="currentColor"
      />
    </svg>
  );
};

const NewMessageIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(-516.000000, -99.000000)" fill="currentcolor">
          <path d="M527.786,122.02 L522.414,125.273 C521.925,125.501 521.485,125.029 521.713,124.571 L524.965,119.195 L527.786,122.02 L527.786,122.02 Z M537.239,106.222 L540.776,109.712 L529.536,120.959 C528.22,119.641 526.397,117.817 526.024,117.444 L537.239,106.222 L537.239,106.222 Z M540.776,102.683 C541.164,102.294 541.793,102.294 542.182,102.683 L544.289,104.791 C544.677,105.18 544.677,105.809 544.289,106.197 L542.182,108.306 L538.719,104.74 L540.776,102.683 L540.776,102.683 Z M524.11,117.068 L519.81,125.773 C519.449,126.754 520.233,127.632 521.213,127.177 L529.912,122.874 C530.287,122.801 530.651,122.655 530.941,122.365 L546.396,106.899 C547.172,106.124 547.172,104.864 546.396,104.088 L542.884,100.573 C542.107,99.797 540.85,99.797 540.074,100.573 L524.619,116.038 C524.328,116.329 524.184,116.693 524.11,117.068 L524.11,117.068 Z M546,111 L546,127 C546,128.099 544.914,129.012 543.817,129.012 L519.974,129.012 C518.877,129.012 517.987,128.122 517.987,127.023 L517.987,103.165 C517.987,102.066 518.902,101 520,101 L536,101 L536,99 L520,99 C517.806,99 516,100.969 516,103.165 L516,127.023 C516,129.22 517.779,131 519.974,131 L543.817,131 C546.012,131 548,129.196 548,127 L548,111 L546,111 L546,111 Z"></path>
        </g>
      </g>
    </svg>
  );
};
const NoIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M213.333 960c0-167.36 56-321.707 149.44-446.4L1406.4 1557.227c-124.693 93.44-279.04 149.44-446.4 149.44-411.627 0-746.667-335.04-746.667-746.667m1493.334 0c0 167.36-56 321.707-149.44 446.4L513.6 362.773c124.693-93.44 279.04-149.44 446.4-149.44 411.627 0 746.667 335.04 746.667 746.667M960 0C429.76 0 0 429.76 0 960s429.76 960 960 960 960-429.76 960-960S1490.24 0 960 0"
        fillRule="evenodd"
      />
    </svg>
  );
};
const NoteIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H13V14C13 13.4477 13.4477 13 14 13H19V6C19 5.44772 18.5523 5 18 5H6ZM17.5858 15H15V17.5858L17.5858 15ZM3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V14C21 14.2652 20.8946 14.5196 20.7071 14.7071L14.7071 20.7071C14.5196 20.8946 14.2652 21 14 21H6C4.34315 21 3 19.6569 3 18V6Z"
        fill="currentColor"
      />
    </svg>
  );
};

const PermissionsIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1600 1066.667c117.653 0 213.333 95.68 213.333 213.333v106.667H1920V1760c0 88.213-71.787 160-160 160h-320c-88.213 0-160-71.787-160-160v-373.333h106.667V1280c0-117.653 95.68-213.333 213.333-213.333ZM800 0c90.667 0 179.2 25.6 254.933 73.6 29.867 18.133 58.667 40.533 84.267 66.133 49.067 49.067 84.8 106.88 108.053 169.814 11.307 30.4 20.8 61.44 25.814 94.08l2.24 14.613 3.626 20.16-.533.32v.213l-52.693 32.427c-44.694 28.907-95.467 61.547-193.067 61.867-.427 0-.747.106-1.173.106-24.534 0-46.08-2.133-65.28-5.653-.64-.107-1.067-.32-1.707-.427-56.32-10.773-93.013-34.24-126.293-55.68-9.6-6.293-18.774-12.16-28.16-17.6-27.947-16-57.92-27.306-108.16-27.306h-.32c-57.814.106-88.747 15.893-121.387 36.266-4.48 2.88-8.853 5.44-13.44 8.427-3.093 2.027-6.72 4.16-9.92 6.187-6.293 4.053-12.693 8.106-19.627 12.16-4.48 2.666-9.493 5.013-14.293 7.573-6.933 3.627-13.973 7.147-21.76 10.453-6.613 2.987-13.76 5.547-21.12 8.107-6.933 2.347-14.507 4.267-22.187 6.293-8.96 2.347-17.813 4.587-27.84 6.187-1.173.213-2.133.533-3.306.747v57.6c0 17.066 1.066 34.133 4.266 50.133C454.4 819.2 611.2 960 800 960c195.2 0 356.267-151.467 371.2-342.4 48-14.933 82.133-37.333 108.8-54.4v23.467c0 165.546-84.373 311.786-212.373 398.08h4.906a1641.19 1641.19 0 0 1 294.08 77.76C1313.28 1119.68 1280 1195.733 1280 1280h-106.667v480c0 1.387.427 2.667.427 4.16-142.933 37.547-272.427 49.173-373.76 49.173-345.493 0-612.053-120.32-774.827-221.333L0 1576.32v-196.373c0-140.054 85.867-263.04 218.667-313.28 100.373-38.08 204.586-64.96 310.186-82.347h4.8C419.52 907.413 339.2 783.787 323.2 640c-2.133-17.067-3.2-35.2-3.2-53.333V480c0-56.533 9.6-109.867 27.733-160C413.867 133.333 592 0 800 0Zm800 1173.333c-58.773 0-106.667 47.894-106.667 106.667v106.667h213.334V1280c0-58.773-47.894-106.667-106.667-106.667Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
const ParentIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="-1 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zm-7.152.384a2.324 2.324 0 0 1-.236-.428 2.28 2.28 0 0 1-.094-.267H5.153a2.247 2.247 0 0 0-2.24 2.24v1.345a.899.899 0 0 0 .896.896h3.827a1.37 1.37 0 0 1-.146-.617v-.926a2.314 2.314 0 0 1 1.408-2.123 2.247 2.247 0 0 1 .367-.12zM7.17 8.6a2.29 2.29 0 1 0-2.29-2.29A2.29 2.29 0 0 0 7.17 8.6zm5.402 2.068H9.796a1.547 1.547 0 0 0-1.543 1.542v.926a.619.619 0 0 0 .617.617h4.628a.619.619 0 0 0 .617-.617v-.926a1.547 1.547 0 0 0-1.543-1.542zm-1.388-.463a1.576 1.576 0 1 0-1.576-1.577 1.576 1.576 0 0 0 1.576 1.577z" />
    </svg>
  );
};
const PhotoUploadIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 4H8.8C7.11984 4 6.27976 4 5.63803 4.32698C5.07354 4.6146 4.6146 5.07354 4.32698 5.63803C4 6.27976 4 7.11984 4 8.8V15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20H15.2C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2V11"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 16L8.29289 11.7071C8.68342 11.3166 9.31658 11.3166 9.70711 11.7071L13 15M13 15L15.7929 12.2071C16.1834 11.8166 16.8166 11.8166 17.2071 12.2071L20 15M13 15L15.25 17.25"
        stroke="#000000"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 8V3M18 3L16 5M18 3L20 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const PlayIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.6935 15.8458L15.4137 13.059C16.1954 12.5974 16.1954 11.4026 15.4137 10.941L10.6935 8.15419C9.93371 7.70561 9 8.28947 9 9.21316V14.7868C9 15.7105 9.93371 16.2944 10.6935 15.8458Z"
        fill="currentColor"
      />
    </svg>
  );
};

const PowerIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 7V12M8 8.99951C7.37209 9.83526 7 10.8742 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 10.8742 16.6279 9.83526 16 8.99951M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const PrintIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9V2H18V9M6 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H20C20.5304 9 21.0391 9.21071 21.4142 9.58579C21.7893 9.96086 22 10.4696 22 11V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H18M6 14H18V22H6V14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const PreferencesIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Icon-Set"
          transform="translate(-152.000000, -359.000000)"
          fill="currentColor"
        >
          <path
            d="M182,387 C182,388.104 181.104,389 180,389 L156,389 C154.896,389 154,388.104 154,387 L154,363 C154,361.896 154.896,361 156,361 L180,361 C181.104,361 182,361.896 182,363 L182,387 L182,387 Z M180,359 L156,359 C153.791,359 152,360.791 152,363 L152,387 C152,389.209 153.791,391 156,391 L180,391 C182.209,391 184,389.209 184,387 L184,363 C184,360.791 182.209,359 180,359 L180,359 Z M172,378.4 C170.674,378.4 169.6,377.325 169.6,376 C169.6,374.675 170.674,373.6 172,373.6 C173.326,373.6 174.4,374.675 174.4,376 C174.4,377.325 173.326,378.4 172,378.4 L172,378.4 Z M178,375 L175.858,375 C175.413,373.277 173.862,372 172,372 C170.138,372 168.588,373.277 168.142,375 L158,375 C157.448,375 157,375.448 157,376 C157,376.553 157.448,377 158,377 L168.142,377 C168.587,378.723 170.138,380 172,380 C173.862,380 175.413,378.723 175.858,377 L178,377 C178.552,377 179,376.553 179,376 C179,375.448 178.552,375 178,375 L178,375 Z M163,370.4 C161.674,370.4 160.6,369.325 160.6,368 C160.6,366.675 161.674,365.601 163,365.601 C164.326,365.601 165.4,366.675 165.4,368 C165.4,369.325 164.326,370.4 163,370.4 L163,370.4 Z M178,367 L166.858,367 C166.413,365.277 164.862,364 163,364 C161.138,364 159.587,365.277 159.142,367 L158,367 C157.448,367 157,367.448 157,368 C157,368.553 157.448,369 158,369 L159.142,369 C159.587,370.723 161.138,372 163,372 C164.862,372 166.413,370.723 166.858,369 L178,369 C178.552,369 179,368.553 179,368 C179,367.448 178.552,367 178,367 L178,367 Z M163,386.4 C161.674,386.4 160.6,385.325 160.6,384 C160.6,382.675 161.674,381.601 163,381.601 C164.326,381.601 165.4,382.675 165.4,384 C165.4,385.325 164.326,386.4 163,386.4 L163,386.4 Z M178,383 L166.858,383 C166.413,381.278 164.862,380 163,380 C161.138,380 159.587,381.278 159.142,383 L158,383 C157.448,383 157,383.447 157,384 C157,384.553 157.448,385 158,385 L159.142,385 C159.587,386.723 161.138,388 163,388 C164.862,388 166.413,386.723 166.858,385 L178,385 C178.552,385 179,384.553 179,384 C179,383.447 178.552,383 178,383 L178,383 Z"
            id="preferences"
          ></path>
        </g>
      </g>
    </svg>
  );
};

const QuoteMarkIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.09 11.6314H3.4C3.48 6.96144 4.4 6.19144 7.27 4.49144C7.6 4.29144 7.71 3.87144 7.51 3.53144C7.32 3.20144 6.89 3.09144 6.56 3.29144C3.18 5.29144 2 6.51144 2 12.3214V17.7114C2 19.4214 3.39 20.8014 5.09 20.8014H8.09C9.85 20.8014 11.18 19.4714 11.18 17.7114V14.7114C11.18 12.9614 9.85 11.6314 8.09 11.6314Z"
        fill="currentColor"
      />
      <path
        d="M18.9086 11.6314H14.2186C14.2986 6.96144 15.2186 6.19144 18.0886 4.49144C18.4186 4.29144 18.5286 3.87144 18.3286 3.53144C18.1286 3.20144 17.7086 3.09144 17.3686 3.29144C13.9886 5.29144 12.8086 6.51144 12.8086 12.3314V17.7214C12.8086 19.4314 14.1986 20.8114 15.8986 20.8114H18.8986C20.6586 20.8114 21.9886 19.4814 21.9886 17.7214V14.7214C21.9986 12.9614 20.6686 11.6314 18.9086 11.6314Z"
        fill="currentColor"
      />
    </svg>
  );
};

const RefreshIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const RockerUserIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M512,298.32l-48.373-60.855l37.57-50.636l-76.622-37.496V79.981l-75.917,21.455L307.26,38.222l-51.26,42.19l-51.26-42.19
			l-41.398,63.213L87.425,79.981v69.352l-76.622,37.496l37.57,50.636L0,298.32l50.266,32.43l-16.311,65.24l56.215,4.818l6.634,72.97
			l72.051-32.424c24.069,18.777,54.322,29.98,87.144,29.98s63.075-11.203,87.144-29.98l72.051,32.424l6.634-72.97l56.215-4.818
			l-16.311-65.24L512,298.32z M365.536,329.4c0,60.399-49.137,109.536-109.536,109.536c-60.398,0-109.536-49.138-109.536-109.536
			v-46.777h219.072V329.4z M146.464,250.224V222.27h31.959l-16.973,27.954H146.464z M199.353,250.224l16.972-27.954h29.055
			l-16.972,27.954H199.353z M266.311,250.224l16.972-27.954h29.055l-16.972,27.954H266.311z M365.535,250.224h-32.266l16.972-27.954
			h15.294V250.224z M392.021,370.846l-4.975,54.736l-19.345-8.706c18.933-24.122,30.236-54.505,30.236-87.477V189.871h-283.87
			v139.53c0,32.972,11.303,63.354,30.236,87.477l-19.345,8.706l-4.975-54.736l-45.369-3.889l12.713-50.855l-39.708-25.618
			l41.602-52.338L60.033,198.81l59.791-29.259v-46.744l57.593,16.276L212.049,86.2l43.951,36.174L299.952,86.2l34.632,52.882
			l57.593-16.276v46.744l59.791,29.259l-29.186,39.338l41.601,52.336l-39.708,25.618l12.713,50.855L392.021,370.846z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle cx="205.765" cy="334.788" r="21.599" />
        </g>
      </g>
      <g>
        <g>
          <circle cx="306.234" cy="334.788" r="21.599" />
        </g>
      </g>
      <g>
        <g>
          <rect x="226.835" y="379.628" width="58.318" height="32.399" />
        </g>
      </g>
    </svg>
  );
};

const RecordIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-380.000000, -3839.000000)" fill="currentColor">
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path d="M338,3689 C338,3691.209 336.209,3693 334,3693 C331.791,3693 330,3691.209 330,3689 C330,3686.791 331.791,3685 334,3685 C336.209,3685 338,3686.791 338,3689 M334,3697 C329.589,3697 326,3693.411 326,3689 C326,3684.589 329.589,3681 334,3681 C338.411,3681 342,3684.589 342,3689 C342,3693.411 338.411,3697 334,3697 M334,3679 C328.477,3679 324,3683.477 324,3689 C324,3694.523 328.477,3699 334,3699 C339.523,3699 344,3694.523 344,3689 C344,3683.477 339.523,3679 334,3679"></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
const RobotIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 8.5C5 8.22386 5.22386 8 5.5 8C5.77614 8 6 8.22386 6 8.5C6 8.77614 5.77614 9 5.5 9C5.22386 9 5 8.77614 5 8.5Z"
        fill="currentColor"
      />
      <path
        d="M9 8.5C9 8.22386 9.22386 8 9.5 8C9.77614 8 10 8.22386 10 8.5C10 8.77614 9.77614 9 9.5 9C9.22386 9 9 8.77614 9 8.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.02242C10.8033 2.27504 13 4.63098 13 7.5V13.5C13 14.3284 12.3284 15 11.5 15H3.5C2.67157 15 2 14.3284 2 13.5V7.5C2 4.63098 4.19675 2.27504 7 2.02242V0H8V2.02242ZM5.5 7C4.67157 7 4 7.67157 4 8.5C4 9.32843 4.67157 10 5.5 10C6.32843 10 7 9.32843 7 8.5C7 7.67157 6.32843 7 5.5 7ZM9.5 7C8.67157 7 8 7.67157 8 8.5C8 9.32843 8.67157 10 9.5 10C10.3284 10 11 9.32843 11 8.5C11 7.67157 10.3284 7 9.5 7ZM11 12H4V11H11V12Z"
        fill="currentColor"
      />
      <path d="M0 8V12H1V8H0Z" fill="currentColor" />
      <path d="M15 8H14V12H15V8Z" fill="currentColor" />
    </svg>
  );
};

const RewindIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1064.719 308.99 0 959.644 1064.719 1610.3v-522.363l855.174 521.829V309.524L1064.72 831.246z"
        fillRule="evenodd"
      />
    </svg>
  );
};
const SecureIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4472 1.10557C12.1657 0.964809 11.8343 0.964809 11.5528 1.10557L3.55279 5.10557C3.214 5.27496 3 5.62123 3 6V12C3 14.6622 3.86054 16.8913 5.40294 18.7161C6.92926 20.5218 9.08471 21.8878 11.6214 22.9255C11.864 23.0248 12.136 23.0248 12.3786 22.9255C14.9153 21.8878 17.0707 20.5218 18.5971 18.7161C20.1395 16.8913 21 14.6622 21 12V6C21 5.62123 20.786 5.27496 20.4472 5.10557L12.4472 1.10557ZM5 12V6.61803L12 3.11803L19 6.61803V12C19 14.1925 18.305 15.9635 17.0696 17.425C15.8861 18.8252 14.1721 19.9803 12 20.9156C9.82786 19.9803 8.11391 18.8252 6.93039 17.425C5.69502 15.9635 5 14.1925 5 12ZM16.7572 9.65323C17.1179 9.23507 17.0714 8.60361 16.6532 8.24284C16.2351 7.88207 15.6036 7.9286 15.2428 8.34677L10.7627 13.5396L8.70022 11.5168C8.30592 11.1301 7.67279 11.1362 7.28607 11.5305C6.89935 11.9248 6.90549 12.5579 7.29978 12.9446L10.1233 15.7139C10.3206 15.9074 10.5891 16.0106 10.8651 15.9991C11.1412 15.9876 11.4002 15.8624 11.5807 15.6532L16.7572 9.65323Z"
        fill="currentColor"
      />
    </svg>
  );
};
const SendIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3938 2.20468C3.70395 1.96828 4.12324 1.93374 4.4679 2.1162L21.4679 11.1162C21.7953 11.2895 22 11.6296 22 12C22 12.3704 21.7953 12.7105 21.4679 12.8838L4.4679 21.8838C4.12324 22.0662 3.70395 22.0317 3.3938 21.7953C3.08365 21.5589 2.93922 21.1637 3.02382 20.7831L4.97561 12L3.02382 3.21692C2.93922 2.83623 3.08365 2.44109 3.3938 2.20468ZM6.80218 13L5.44596 19.103L16.9739 13H6.80218ZM16.9739 11H6.80218L5.44596 4.89699L16.9739 11Z"
        fill="currentColor"
      />
    </svg>
  );
};

const ShareScreenIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width * 1.25} h-${height * 1.25}`}
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="screenshare"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="screenshareFilled" fill="currentColor" fillRule="nonzero">
          <path
            d="M23.75,4.99939 C24.9926,4.99939 26,6.00675 26,7.24939 L26,7.24939 L26,20.75 C26,21.9926 24.9926,23 23.75,23 L23.75,23 L4.25,23 C3.00736,23 2,21.9926 2,20.75 L2,20.75 L2,7.24939 C2,6.00675 3.00736,4.99939 4.25,4.99939 L4.25,4.99939 Z M13.9975,8.62108995 C13.7985,8.62108995 13.6077,8.70032 13.467,8.84113 L10.217,12.0956 C9.92435,12.3887 9.92468,12.8636 10.2178,13.1563 C10.5109,13.449 10.9858,13.4487 11.2784,13.1556 L13.2477,11.1835 L13.2477,18.6285 C13.2477,19.0427 13.5835,19.3785 13.9977,19.3785 C14.4119,19.3785 14.7477,19.0427 14.7477,18.6285 L14.7477,11.1818 L16.7219,13.1559 C17.0148,13.4488 17.4897,13.4488 17.7826,13.1559 C18.0755,12.863 18.0755,12.3882 17.7826,12.0953 L14.5281,8.84076 C14.3873,8.70005 14.1965,8.62108995 13.9975,8.62108995 Z"
            id="fillScreen"
          ></path>
        </g>
      </g>
    </svg>
  );
};

const SlashIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const SoundWaveIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46447 3.46447C2 4.92893 2 7.28595 2 12C2 16.714 2 19.0711 3.46447 20.5355C4.92893 22 7.28595 22 12 22C16.714 22 19.0711 22 20.5355 20.5355C22 19.0711 22 16.714 22 12C22 7.28595 22 4.92893 20.5355 3.46447C19.0711 2 16.714 2 12 2C7.28595 2 4.92893 2 3.46447 3.46447ZM12.75 7C12.75 6.58579 12.4142 6.25 12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V7ZM7.75 9C7.75 8.58579 7.41421 8.25 7 8.25C6.58579 8.25 6.25 8.58579 6.25 9V15C6.25 15.4142 6.58579 15.75 7 15.75C7.41421 15.75 7.75 15.4142 7.75 15V9ZM17.75 10C17.75 9.58579 17.4142 9.25 17 9.25C16.5858 9.25 16.25 9.58579 16.25 10V14C16.25 14.4142 16.5858 14.75 17 14.75C17.4142 14.75 17.75 14.4142 17.75 14V10Z"
        fill="currentcolor"
      />
    </svg>
  );
};

const SpiralIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="-1 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="P" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Dr"
          transform="translate(-381.000000, -8039.000000)"
          fill="currentColor"
        >
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path
              d="M336.622775,7895.01452 C333.022714,7895.3213 329.929083,7892.89808 329.177444,7889.58357 C328.445822,7886.35728 330.675718,7883.02874 333.977526,7883.00969 C336.468644,7882.99565 338.540405,7884.8043 338.941747,7887.1814 C339.245004,7888.98202 338.148072,7890.82275 336.33453,7891.01324 C334.529995,7891.20273 333.0067,7889.7911 333.0067,7888.02256 C333.0067,7887.46914 333.455081,7887.01999 334.007551,7887.01999 C334.560021,7887.01999 335.008402,7887.46914 335.008402,7888.02256 C335.008402,7888.57598 335.456783,7889.02513 336.009253,7889.02513 C336.561723,7889.02513 337.010104,7888.57598 337.010104,7888.02256 C337.010104,7886.25402 335.486809,7884.84239 333.682275,7885.03188 C331.868733,7885.22337 330.7718,7887.0631 331.075058,7888.86372 C331.476399,7891.24183 333.548161,7893.04947 336.039279,7893.03543 C339.341086,7893.01638 341.570982,7889.68784 340.83936,7886.46155 C339.941597,7882.49938 335.695987,7879.81147 331.240198,7881.5369 C328.964263,7882.41716 327.340883,7884.52758 327.062646,7886.95582 C326.472144,7892.11507 330.230339,7896.53241 335.138513,7897.00463 C335.637937,7897.05275 336.009253,7897.49088 336.009253,7897.99417 C336.009253,7898.5917 335.488811,7899.05489 334.894305,7898.99474 C329.388624,7898.44031 325.07996,7893.82346 325.000893,7888.18097 C324.940842,7883.91401 327.915371,7880.06111 332.086918,7879.1989 C337.477502,7878.08404 342.265573,7881.79657 342.935142,7886.81546 C343.469596,7890.82075 340.642192,7894.67164 336.622775,7895.01452"
              id="-spiral-[#30]"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

const StarCircleIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentcolor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 27.9999 51.9063 C 41.0546 51.9063 51.9063 41.0781 51.9063 28 C 51.9063 14.9453 41.0312 4.0937 27.9765 4.0937 C 14.8983 4.0937 4.0937 14.9453 4.0937 28 C 4.0937 41.0781 14.9218 51.9063 27.9999 51.9063 Z M 18.6483 41.0547 C 18.0858 40.6328 17.9921 39.9531 18.3202 38.9922 L 21.1796 30.4375 L 13.8671 25.2109 C 13.0234 24.6250 12.7187 23.9688 12.9062 23.3125 C 13.1171 22.6797 13.7733 22.3516 14.7812 22.3516 L 23.7812 22.4219 L 26.5234 13.8203 C 26.8046 12.8594 27.2968 12.3437 27.9999 12.3437 C 28.7030 12.3437 29.1718 12.8594 29.4765 13.8203 L 32.2187 22.4219 L 41.1952 22.3516 C 42.2265 22.3516 42.8358 22.6797 43.0702 23.3125 C 43.3046 23.9688 42.9530 24.6250 42.1327 25.2109 L 34.7968 30.4375 L 37.6562 38.9922 C 37.9843 39.9531 37.8905 40.6328 37.3514 41.0547 C 36.7655 41.5000 36.0858 41.3359 35.2655 40.7266 L 27.9999 35.4063 L 20.7343 40.7266 C 19.8905 41.3359 19.2109 41.5000 18.6483 41.0547 Z" />
    </svg>
  );
};

const SquareGridIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentcolor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 10.9023 26.0664 L 21.5898 26.0664 C 24.5663 26.0664 26.0663 24.5664 26.0663 21.4727 L 26.0663 10.9961 C 26.0663 7.9023 24.5663 6.4258 21.5898 6.4258 L 10.9023 6.4258 C 7.9257 6.4258 6.4257 7.9023 6.4257 10.9961 L 6.4257 21.4727 C 6.4257 24.5664 7.9257 26.0664 10.9023 26.0664 Z M 34.4335 26.0664 L 45.0976 26.0664 C 48.0976 26.0664 49.5743 24.5664 49.5743 21.4727 L 49.5743 10.9961 C 49.5743 7.9023 48.0976 6.4258 45.0976 6.4258 L 34.4335 6.4258 C 31.4570 6.4258 29.9570 7.9023 29.9570 10.9961 L 29.9570 21.4727 C 29.9570 24.5664 31.4570 26.0664 34.4335 26.0664 Z M 10.9492 22.7617 C 10.1288 22.7617 9.7304 22.3398 9.7304 21.4727 L 9.7304 10.9961 C 9.7304 10.1523 10.1288 9.7305 10.9492 9.7305 L 21.5195 9.7305 C 22.3398 9.7305 22.7617 10.1523 22.7617 10.9961 L 22.7617 21.4727 C 22.7617 22.3398 22.3398 22.7617 21.5195 22.7617 Z M 34.4804 22.7617 C 33.6601 22.7617 33.2617 22.3398 33.2617 21.4727 L 33.2617 10.9961 C 33.2617 10.1523 33.6601 9.7305 34.4804 9.7305 L 45.0742 9.7305 C 45.8710 9.7305 46.2695 10.1523 46.2695 10.9961 L 46.2695 21.4727 C 46.2695 22.3398 45.8710 22.7617 45.0742 22.7617 Z M 10.9023 49.5742 L 21.5898 49.5742 C 24.5663 49.5742 26.0663 48.0977 26.0663 45.0039 L 26.0663 34.5039 C 26.0663 31.4336 24.5663 29.9336 21.5898 29.9336 L 10.9023 29.9336 C 7.9257 29.9336 6.4257 31.4336 6.4257 34.5039 L 6.4257 45.0039 C 6.4257 48.0977 7.9257 49.5742 10.9023 49.5742 Z M 34.4335 49.5742 L 45.0976 49.5742 C 48.0976 49.5742 49.5743 48.0977 49.5743 45.0039 L 49.5743 34.5039 C 49.5743 31.4336 48.0976 29.9336 45.0976 29.9336 L 34.4335 29.9336 C 31.4570 29.9336 29.9570 31.4336 29.9570 34.5039 L 29.9570 45.0039 C 29.9570 48.0977 31.4570 49.5742 34.4335 49.5742 Z M 10.9492 46.2695 C 10.1288 46.2695 9.7304 45.8477 9.7304 45.0039 L 9.7304 34.5274 C 9.7304 33.6602 10.1288 33.2383 10.9492 33.2383 L 21.5195 33.2383 C 22.3398 33.2383 22.7617 33.6602 22.7617 34.5274 L 22.7617 45.0039 C 22.7617 45.8477 22.3398 46.2695 21.5195 46.2695 Z M 34.4804 46.2695 C 33.6601 46.2695 33.2617 45.8477 33.2617 45.0039 L 33.2617 34.5274 C 33.2617 33.6602 33.6601 33.2383 34.4804 33.2383 L 45.0742 33.2383 C 45.8710 33.2383 46.2695 33.6602 46.2695 34.5274 L 46.2695 45.0039 C 46.2695 45.8477 45.8710 46.2695 45.0742 46.2695 Z" />
    </svg>
  );
};

const StarIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`w-${width} h-${height}`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
      ></path>
    </svg>
  );
};
const StopIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-520.000000, -571.000000)" fill="currentColor">
          <path
            d="M546,571 L522,571 C520.896,571 520,571.896 520,573 L520,597 C520,598.104 520.896,599 522,599 L546,599 C547.104,599 548,598.104 548,597 L548,573 C548,571.896 547.104,571 546,571"
            id="stop"
          ></path>
        </g>
      </g>
    </svg>
  );
};
const StopIcon2: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="14" height="14" fill="currentColor" />
    </svg>
  );
};

const TimeZoneIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 17.5C11 17.1593 11.0262 16.8247 11.0767 16.4981L8.90581 16.4989L8.96386 16.7934C9.60097 19.9032 10.8046 21.9971 12.0016 21.9971C12.2125 21.9971 12.4237 21.932 12.6314 21.8067C11.6162 20.6599 11 19.1519 11 17.5Z"
        fill="currentcolor"
      />
      <path
        d="M9.16518 21.5923C8.35605 20.3526 7.73777 18.5811 7.37299 16.4988L3.06735 16.499C4.29868 18.9386 6.49983 20.8051 9.16518 21.5923Z"
        fill="currentcolor"
      />
      <path
        d="M7 11.9985C7 11.3171 7.02384 10.6488 7.07009 9.99886L2.20006 9.99825C2.06887 10.6446 2 11.3135 2 11.9985C2 13.0439 2.16037 14.0517 2.45784 14.9989H7.16047L7.10335 14.4187C7.03531 13.6377 7 12.8279 7 11.9985Z"
        fill="currentcolor"
      />
      <path
        d="M15.4942 11.3146C15.4825 10.8668 15.4595 10.4274 15.4261 9.99829H8.57704L8.54381 10.4868C8.51507 10.9794 8.5 11.4842 8.5 11.9985C8.5 13.0456 8.56246 14.0532 8.67551 14.999L11.4988 14.9984C12.225 13.2585 13.6857 11.9017 15.4942 11.3146Z"
        fill="currentcolor"
      />
      <path
        d="M22.0031 11.9985C22.0031 11.3135 21.9342 10.6446 21.803 9.99825L16.933 9.99886L16.9717 10.6547C16.9774 10.7757 16.9824 10.8973 16.9846 11.0201C17.1547 11.0068 17.3265 11 17.5 11C19.2329 11 20.8074 11.6781 21.9728 12.7832C21.9929 12.5243 22.0031 12.2626 22.0031 11.9985Z"
        fill="currentcolor"
      />
      <path
        d="M21.3735 8.49821C20.2803 5.57247 17.8562 3.29586 14.8379 2.40488L14.9458 2.57511L15.1081 2.85087C15.905 4.26669 16.4868 6.23263 16.7826 8.4985L21.3735 8.49821Z"
        fill="currentcolor"
      />
      <path
        d="M7.28208 8.05866C7.62974 5.73404 8.28435 3.75443 9.1651 2.40492L9.04333 2.4417L8.73908 2.54118C5.91953 3.51365 3.6709 5.71147 2.62963 8.49821L7.22051 8.4985L7.28208 8.05866Z"
        fill="currentcolor"
      />
      <path
        d="M15.2155 8.18344C14.6471 4.54175 13.3203 2 12.0016 2C10.6451 2 9.28014 4.68907 8.74073 8.49825H15.2624L15.2155 8.18344Z"
        fill="currentcolor"
      />
      <path
        d="M23 17.5C23 14.4624 20.5376 12 17.5 12C14.4624 12 12 14.4624 12 17.5C12 20.5376 14.4624 23 17.5 23C20.5376 23 23 20.5376 23 17.5ZM17.5 17.5H19.5C19.7761 17.5 20 17.7239 20 18C20 18.2762 19.7761 18.5 19.5 18.5H17C16.7268 18.5 16.5048 18.2809 16.5001 18.0089L16.5 17.9999V14.9999C16.5 14.7238 16.7239 14.4999 17 14.4999C17.2761 14.4999 17.5 14.7238 17.5 14.9999L17.5 17.5Z"
        fill="currentcolor"
      />
    </svg>
  );
};

const TransferIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Trans">
          <rect
            id="Rectangle"
            fillRule="nonzero"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <path
            d="M19,7 L5,7 M20,17 L5,17"
            id="Shape"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          ></path>
          <path
            d="M16,3 L19.2929,6.29289 C19.6834,6.68342 19.6834,7.31658 19.2929,7.70711 L16,11"
            id="Path"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          ></path>
          <path
            d="M8,13 L4.70711,16.2929 C4.31658,16.6834 4.31658,17.3166 4.70711,17.7071 L8,21"
            id="Path"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          ></path>
        </g>
      </g>
    </svg>
  );
};

const TrebleClefIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 439.909 439.909"
    >
      <g id="XMLID_524_">
        <path
          id="XMLID_530_"
          d="M289.859,218.165c-12.238-12.083-28.92-18.736-46.975-18.736c-0.739,0-1.469,0.011-2.191,0.034
		c-4.751-18.989-9.194-34.531-12.219-44.64c-1.258-4.203-2.437-8.269-3.54-12.192c13.877-15.22,26.345-29.841,33.266-44.593
		c19.623-41.823,10.708-66.709,3.647-77.821C253.684,7.369,240.237,0,224.955,0c-13.893,0-25.356,5.533-33.149,16
		c-15.284,20.528-15.407,58.521-0.127,118.479c-29.22,31.773-60.724,67.762-60.724,112.562c0,47.333,25.917,70.548,47.66,81.688
		c22.534,11.546,45.015,12.242,45.961,12.266l0.379,0.005c3.073,0,6.112-0.127,9.109-0.378l0.103,1.491
		c1.335,19.236,2.489,35.849,0.003,50.352c-2.37,13.822-11.714,18.001-19.006,17.382c-3.07-0.261-10.21-1.744-10.21-9.848h-30
		c0,21.169,15.841,37.883,37.666,39.74c1.33,0.113,2.656,0.17,3.98,0.17c10.054-0.001,19.84-3.24,27.914-9.306
		c10.179-7.647,16.827-19.082,19.225-33.069c3.095-18.055,1.826-36.334,0.356-57.5l-0.317-4.583
		c-0.043-0.64-0.088-1.279-0.135-1.919c6.901-2.901,13.235-6.612,18.807-11.07c17.339-13.872,26.504-33.742,26.504-57.463
		C308.955,246.956,302.173,230.323,289.859,218.165z M215.868,33.916c1.515-2.034,3.663-3.916,9.086-3.916
		c3.451,0,8.261,1.094,11.573,6.307c2.361,3.716,8.945,18.232-5.486,48.989c-3.165,6.746-8.459,14.108-14.908,21.894
		C205.458,56.316,211.865,39.292,215.868,33.916z M225.237,311c-1.764-0.087-18.08-1.109-33.732-9.38
		c-20.557-10.862-30.55-28.715-30.55-54.579c0-27.928,19.13-54.306,40.316-78.423c2.907,9.939,6.715,23.599,10.722,39.708
		c-12.94,9.11-19.038,23.895-19.038,38.007c0,11.36,4.616,21.066,12.997,27.331c6.43,4.806,14.077,6.893,21.186,7.503
		c1.587,9.726,3.009,19.631,4.186,29.57C229.28,310.906,227.245,310.992,225.237,311z M260.389,301.351
		c-3.197-25.015-7.776-49.574-12.6-71.639c18.327,2.149,31.166,16.328,31.166,35.288
		C278.955,282.468,271.257,294.136,260.389,301.351z"
        />
      </g>
    </svg>
  );
};

const ToolIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="none"
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      color="currentColor"
    >
      <path d="M9.74292939,13.7429294 C9.19135019,13.9101088 8.60617271,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,7.07370693 2.20990431,6.19643964 2.58474197,5.4131691 L6.94974747,9.77817459 L9.77817459,6.94974747 L5.4131691,2.58474197 C6.19643964,2.20990431 7.07370693,2 8,2 C11.3137085,2 14,4.6862915 14,8 C14,8.88040772 13.8103765,9.71652648 13.4697429,10.4697429 L20.5858636,17.5858636 C21.3669122,18.3669122 21.3669122,19.6332422 20.5858636,20.4142907 L19.9142907,21.0858636 C19.1332422,21.8669122 17.8669122,21.8669122 17.0858636,21.0858636 L9.74292939,13.7429294 Z" />
    </svg>
  );
};

const UserCheckIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 -64 640 640"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z" />
    </svg>
  );
};

const UserPlusIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 -64 640 640"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" />
    </svg>
  );
};

const UsersIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="924 578 200 200"
    >
      <g>
        <g>
          <path
            d="M984.585,638.942c0,13.999-9.609,25.348-21.462,25.348c-11.852,0-21.459-11.349-21.459-25.348
			c0-13.998,9.607-25.346,21.459-25.346C974.976,613.596,984.585,624.944,984.585,638.942z"
          />
          <path
            d="M987.585,683.641c1.55-0.945,3.265-1.561,5.041-1.855c-3.606-5.088-6.161-10.546-7.637-17.078
			c-0.404-2.387-3.672-2.667-6.102-0.687c-4.546,3.706-9.849,6.186-15.765,6.186c-6.03,0-11.577-2.399-16.024-6.414
			c-1.419-1.282-3.51-1.476-5.143-0.479c-8.443,5.158-14.834,13.344-17.622,23.067c-0.749,2.605-0.223,5.42,1.411,7.588
			c1.636,2.166,4.192,3.443,6.906,3.443h38.668C975.947,692.072,981.41,687.41,987.585,683.641z"
          />
        </g>
        <g>
          <path
            d="M1063.416,638.942c0,13.999,9.608,25.348,21.461,25.348c11.854,0,21.46-11.349,21.46-25.348
			c0-13.998-9.606-25.346-21.46-25.346C1073.024,613.596,1063.416,624.944,1063.416,638.942z"
          />
          <path
            d="M1060.415,683.641c-1.55-0.945-3.266-1.561-5.041-1.855c3.606-5.088,6.161-10.546,7.637-17.078
			c0.405-2.387,3.673-2.667,6.103-0.687c4.546,3.706,9.848,6.186,15.764,6.186c6.029,0,11.577-2.399,16.025-6.414
			c1.419-1.282,3.509-1.476,5.142-0.479c8.444,5.158,14.836,13.344,17.622,23.067c0.748,2.605,0.223,5.42-1.41,7.588
			c-1.637,2.166-4.192,3.443-6.905,3.443h-38.67C1072.053,692.072,1066.591,687.41,1060.415,683.641z"
          />
        </g>
        <g>
          <path
            d="M1082.475,725.451c-4.198-14.654-13.72-27.045-26.326-34.992c-2.487-1.566-5.715-1.313-7.921,0.631
			c-6.766,5.959-15.138,9.506-24.228,9.506c-9.269,0-17.791-3.686-24.626-9.855c-2.182-1.971-5.393-2.268-7.902-0.734
			c-12.977,7.924-22.799,20.504-27.082,35.445c-1.151,4.008-0.344,8.328,2.166,11.662c2.516,3.33,6.443,5.291,10.615,5.291h92.523
			c4.173,0,8.103-1.955,10.618-5.291C1082.823,733.779,1083.626,729.463,1082.475,725.451z"
          />
          <path
            d="M1056.981,652.547c0,21.513-14.766,38.955-32.981,38.955c-18.214,0-32.979-17.442-32.979-38.955
			c0-21.515,14.765-38.951,32.979-38.951C1042.216,613.596,1056.981,631.033,1056.981,652.547z"
          />
        </g>
      </g>
    </svg>
  );
};
const UserStaffIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          d="M12 14v8H4a8 8 0 0 1 8-8zm6 7.5l-2.939 1.545.561-3.272-2.377-2.318 3.286-.478L18 14l1.47 2.977 3.285.478-2.377 2.318.56 3.272L18 21.5zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const VideoIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width * 1.25} h-${height * 1.25}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6H16C16.55 6 17 6.45 17 7V10.5L21 6.5V17.5L17 13.5V17C17 17.55 16.55 18 16 18H4C3.45 18 3 17.55 3 17V7C3 6.45 3.45 6 4 6Z"
        fill="currentColor"
      />
    </svg>
  );
};
const VideoOffIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m1421.141 3.007 91.775 64.262L215.481 1919.55l.595.417-.378.54-92.37-64.679L246.487 1680H0V240h1255.139L1421.141 3.007Zm79.395 278.487V791.83L1920 346.05v1228.01l-419.464-445.892V1680H520.95l979.586-1398.506Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

const ViewIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.83 11.2807C19.542 7.15186 15.8122 5 12 5C8.18777 5 4.45796 7.15186 2.17003 11.2807C1.94637 11.6844 1.94361 12.1821 2.16029 12.5876C4.41183 16.8013 8.1628 19 12 19C15.8372 19 19.5882 16.8013 21.8397 12.5876C22.0564 12.1821 22.0536 11.6844 21.83 11.2807ZM12 17C9.06097 17 6.04052 15.3724 4.09173 11.9487C6.06862 8.59614 9.07319 7 12 7C14.9268 7 17.9314 8.59614 19.9083 11.9487C17.9595 15.3724 14.939 17 12 17Z"
        fill="currentColor"
      />
    </svg>
  );
};

const WarningIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896zm0 192a58.432 58.432 0 0 0-58.24 63.744l23.36 256.384a35.072 35.072 0 0 0 69.76 0l23.296-256.384A58.432 58.432 0 0 0 512 256zm0 512a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4z"
      />
    </svg>
  );
};

const ZoomIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.44914 3.3335C0.648801 3.3335 0 3.9823 0 4.78263V9.76855C0 11.3692 1.2976 12.6668 2.89827 12.6668H9.8842C10.6845 12.6668 11.3333 12.018 11.3333 11.2177V6.23177C11.3333 4.6311 10.0357 3.3335 8.43506 3.3335H1.44914ZM16 4.64251V11.3575C16 11.9023 15.3819 12.2171 14.9412 11.8966L12.8824 10.3993C12.5374 10.1484 12.3333 9.74762 12.3333 9.32103V6.67897C12.3333 6.25238 12.5374 5.85156 12.8824 5.60065L14.9412 4.10336C15.3819 3.78289 16 4.09766 16 4.64251Z"
        fill="#0E71EB"
      />
    </svg>
  );
};

export {
  AddIcon,
  ArchiveIcon,
  AttachPaperClipIcon,
  AudioWavIcon,
  BackIcon,
  BookIcon,
  BrainIcon,
  BriefcaseIcon,
  CalendarIcon,
  CameraIcon,
  CheckIcon,
  CheckCircleIcon,
  ClipboardIcon,
  ClockCircleIcon,
  CopyIcon,
  DetailsIcon,
  DeleteIcon,
  DotsIcon,
  DuplicateIcon,
  EditIcon,
  EigthNoteIcon,
  EmojiSingIcon,
  ExitIcon,
  ExpandIcon,
  ExpandIcon2,
  ExpandIcon3,
  ExternalLinkIcon,
  EyeIcon,
  FastForwardIcon,
  FilterIcon,
  ForwardIcon,
  FullScreenIcon,
  GuitarPickIcon,
  GuitarCaseIcon,
  HamburgerIcon,
  HamburgerNavIcon,
  HelpIcon,
  HereNowIcon,
  HomeIcon,
  HomeHeartIcon,
  HomePhoneIcon,
  ImageIcon,
  InfoIcon,
  LinkIcon,
  ListIcon,
  LoadingErrorIcon,
  LotusFlowerIcon,
  MapPinIcon,
  MenuGridIcon,
  MessagesIcon,
  MessagesOffIcon,
  MicrophoneIcon,
  MicrophoneOffIcon,
  MicrophoneHandIcon,
  MindBlownIcon,
  MinimizeIcon,
  MinusIcon,
  MusicEigthNotesIcon,
  NewMessageIcon,
  NoIcon,
  NoteIcon,
  ParentIcon,
  PermissionsIcon,
  PhotoUploadIcon,
  PlayIcon,
  PowerIcon,
  PrintIcon,
  PreferencesIcon,
  QuoteMarkIcon,
  RecordIcon,
  RefreshIcon,
  RewindIcon,
  RobotIcon,
  RockerUserIcon,
  SecureIcon,
  SendIcon,
  ShareScreenIcon,
  SlashIcon,
  SoundWaveIcon,
  SpiralIcon,
  SquareGridIcon,
  StarCircleIcon,
  StarIcon,
  StopIcon,
  StopIcon2,
  TimeZoneIcon,
  ToolIcon,
  TransferIcon,
  TrebleClefIcon,
  WarningIcon,
  UserCheckIcon,
  UserPlusIcon,
  UserStaffIcon,
  UsersIcon,
  VideoIcon,
  VideoOffIcon,
  ViewIcon,
  ZoomIcon,
};
